export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What are three key objectives of cybersecurity programs?",
    "description": "Confidentiality, integrity, and availability."
  },
  {
    "id": 2,
    "topic_id": 4,
    "title": "What are specific goals of confidentiality, integrity, and availability?",
    "description": "Confidentiality ensures that unauthorized individuals are not able to gain access to sensitive information; integrity ensures that there are no unauthorized modifications to information or systems, either intentionally or unintentionally; and availability ensures that information and systems are ready to meet the needs of legitimate users at the time those users request them."
  },
  {
    "id": 3,
    "topic_id": 2,
    "title": "What are\u00a0three key threats to cybersecurity programs?",
    "description": "Disclosure, alteration, and denial."
  },
  {
    "id": 4,
    "topic_id": 3,
    "title": "What term describes the unauthorized modification of information?",
    "description": "Alteration is the unauthorized modification of information and is a violation of the principle of integrity. Denial is the unintended disruption of an authorized user\u2019s legitimate access to information."
  },
  {
    "id": 5,
    "topic_id": 4,
    "title": "Name all five risk categories.",
    "description": "Financial, reputational, strategic, operational, and compliance."
  },
  {
    "id": 6,
    "topic_id": 4,
    "title": "What are four security control categories?",
    "description": "Technical controls, operational controls, managerial controls, and physical controls."
  },
  {
    "id": 7,
    "topic_id": 3,
    "title": "What are some examples of technical controls?",
    "description": "Firewall rules, access control lists, intrusion prevention systems, and encryption."
  },
  {
    "id": 8,
    "topic_id": 3,
    "title": "What are some examples of operational controls?",
    "description": "User access reviews, log monitoring, and vulnerability management."
  },
  {
    "id": 9,
    "topic_id": 2,
    "title": "What are some examples of managerial controls?",
    "description": "Periodic risk assessments, security planning exercises, and the incorporation of security into the organization\u2019s change management, service acquisition, and project management practices."
  },
  {
    "id": 10,
    "topic_id": 3,
    "title": "Name all security control types",
    "description": "Preventive controls, detective controls, corrective controls, deterrent controls, compensating controls, and directive controls."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "What are three states where data might exist?",
    "description": "Data at rest, data in transit, data in use."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "What is data encryption?",
    "description": "Encryption technology uses mathematical algorithms to protect information from prying eyes, both while it is in transit over a network and while it resides on systems."
  },
  {
    "id": 13,
    "topic_id": 5,
    "title": "What is DLP and what can it do?",
    "description": "DLP is data loss prevention. DLP systems help organizations enforce information handling policies and procedures to prevent data loss and theft."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "Name two different environments that DLP systems work in.",
    "description": "Agent-based DLP and agentless DLP."
  },
  {
    "id": 15,
    "topic_id": 5,
    "title": "Name two mechanisms of action of DLP systems.",
    "description": "Pattern matching and watermarking."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "What is data minimization and how can we do it?",
    "description": "Data minimization techniques seek to reduce risk by reducing the amount of sensitive information that we maintain on a regular basis.\u00a0The best way to achieve data minimization is to simply destroy data when it is no longer necessary to meet our original business purpose."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "What should we do if we can\u2019t completely remove data from a dataset?",
    "description": "We can transform it into a format where the original sensitive information is deidentified.\u00a0The deidentification process removes the ability to link data back to an individual, reducing its sensitivity. An alternative to deidentifying data is transforming it into a format where the original information can\u2019t be retrieved.\u00a0This is a process called data obfuscation."
  },
  {
    "id": 18,
    "topic_id": 3,
    "title": "Name some tools we can use in the process of data obfuscation.",
    "description": "Hashing, tokenization, and masking."
  },
  {
    "id": 19,
    "topic_id": 5,
    "title": "What are some examples of physical controls?",
    "description": "Fences, perimeter lighting, locks, fire suppression systems, and burglar alarms."
  },
  {
    "id": 20,
    "topic_id": 4,
    "title": "What are access restrictions?",
    "description": "Access restrictions are security measures that limit the ability of individuals or systems to access sensitive information or resources."
  },
  {
    "id": 21,
    "topic_id": 4,
    "title": "What are two types of access restrictions?",
    "description": "Geographic restrictions and permission restrictions."
  },
  {
    "id": 22,
    "topic_id": 3,
    "title": "What does segmentation accomplish?",
    "description": "Segmentation places sensitive systems on separate networks where they may communicate with each other but have strict restrictions on their ability to communicate with systems on other networks."
  },
  {
    "id": 23,
    "topic_id": 1,
    "title": "What does isolation do?",
    "description": "Isolation goes a step further and completely cuts a system off from access to or from outside networks."
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What characteristics differentiate the types of cybersecurity threat actors?",
    "description": "Internal vs. external, level of sophistication/capability, resources/funding, intent/motivation."
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "What defines an unskilled attacker?",
    "description": "The term unskilled attacker is a term used for people who use hacking techniques and premade tools but have limited skills."
  },
  {
    "id": 26,
    "topic_id": 2,
    "title": "What is a hacktivist?",
    "description": "A hacktivist uses hacking techniques to accomplish some activist goal."
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "What is organized crime?",
    "description": "Organized crime appears in any case where there is money to be made."
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "What is a nation-state actor?",
    "description": "Nation-state actors are sponsored by or supported by nations and are typically sophisticated and highly resourced."
  },
  {
    "id": 29,
    "topic_id": 2,
    "title": "What is a zero-day attack?",
    "description": "Attacks that exploit vulnerabilities that are not yet disclosed."
  },
  {
    "id": 30,
    "topic_id": 2,
    "title": "What term describes the means that an attacker uses to gain access to a system?",
    "description": "Threat vectors are the means that threat actors use to obtain access to a system."
  },
  {
    "id": 31,
    "topic_id": 4,
    "title": "What is threat intelligence?",
    "description": "Threat intelligence is the set of activities and resources available to cybersecurity professionals seeking to learn about changes in the threat environment."
  },
  {
    "id": 32,
    "topic_id": 4,
    "title": "What is open source threat intelligence?",
    "description": "Open source threat intelligence is threat intelligence that is acquired from publicly available sources."
  },
  {
    "id": 33,
    "topic_id": 4,
    "title": "What are three common questions that come into play when we assess a threat intelligence source or a specific threat intelligence notification?",
    "description": "Is it timely? Is the information accurate? Is the information relevant?"
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "Name some sources you can use when you build your threat research toolkit.",
    "description": "Vendor security information websites, vulnerability and threat feeds from vendors, government agencies, and private organizations, academic journals and technical publications, professional conferences and local industry group meetings, and social media accounts of prominent security professionals."
  },
  {
    "id": 35,
    "topic_id": 2,
    "title": "What type of attacker acts with authorization?",
    "description": "An authorized attacker is one who acts with authorization and seeks to discover security vulnerabilities with the intent of correcting them."
  },
  {
    "id": 36,
    "topic_id": 2,
    "title": "What type of attacker has a malicious intent?",
    "description": "An unauthorized attacker."
  },
  {
    "id": 37,
    "topic_id": 2,
    "title": "What type of attacker acts without proper authorization, but they do so with the intent of informing their targets of any security vulnerabilities?",
    "description": "A semi-authorized attacker."
  },
  {
    "id": 38,
    "topic_id": 2,
    "title": "What is an insider threat?",
    "description": "When an employee, contractor, vendor, or other individual with authorized access to information and systems uses that access to wage an attack against the organization."
  },
  {
    "id": 39,
    "topic_id": 5,
    "title": "What is shadow IT?",
    "description": "IT implementations, systems, and services created through unofficial means, often by well-meaning employees or by employees outside of central IT."
  },
  {
    "id": 40,
    "topic_id": 2,
    "title": "What actor is most commonly associated with corporate espionage?",
    "description": "Competitors may engage in corporate espionage designed to steal sensitive information from your organization and use it to their own business advantage."
  },
  {
    "id": 41,
    "topic_id": 2,
    "title": "Name 10 attacker motivations.",
    "description": "Data exfiltration, espionage, service disruption, blackmail, financial gain, philosophical/political beliefs, ethical, revenge, disruption/chaos, and war."
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "What is an attack surface?",
    "description": "A system, application, or service that contains a vulnerability that attackers might exploit."
  },
  {
    "id": 43,
    "topic_id": 2,
    "title": "Name eight threat vectors.",
    "description": "Message-based threat vectors, wired networks, wireless networks, systems, files and images, removable devices, cloud, and supply chain."
  },
  {
    "id": 44,
    "topic_id": 2,
    "title": "What do you call a network run over standard Internet connections but using multiple layers of encryption to provide anonymous communication?",
    "description": "Dark web."
  },
  {
    "id": 45,
    "topic_id": 4,
    "title": "What do you call a geographic view of threat intelligence?",
    "description": "A threat map."
  },
  {
    "id": 46,
    "topic_id": 1,
    "title": "What is malware?",
    "description": "The term malware describes a wide range of software that is intentionally designed to cause harm to systems and devices, networks, or users."
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "What is ransomware?",
    "description": "Ransomware is malware that takes over a computer then demands a ransom or payment."
  },
  {
    "id": 48,
    "topic_id": 3,
    "title": "What control should organizations put in place to ensure that successful ransomware infections do not incapacitate the company?",
    "description": "One of the most important defenses against ransomware is an effective backup system that stores files in a separate location that will not be impacted if the system or device it backs up is infected and encrypted by ransomware."
  },
  {
    "id": 49,
    "topic_id": 2,
    "title": "What\u2019s the difference between Trojans and worms?",
    "description": "Trojans require user interaction, whereas worms are self-installed and spread themselves."
  },
  {
    "id": 50,
    "topic_id": 2,
    "title": "What are rootkits?",
    "description": "Malware specifically designed to allow attackers to access a system through a backdoor."
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "What is the best way to detect a rootkit?",
    "description": "The best way to detect a rootkit is to test the suspected system from a trusted system or device. In cases where that isn\u2019t possible, rootkit detection tools look for behaviors and signatures that are typical of rootkits."
  },
  {
    "id": 52,
    "topic_id": 2,
    "title": "What are backdoors?",
    "description": "Backdoors are methods or tools that provide access that bypasses normal authentication and authorization procedures, allowing attackers access to systems, devices, or applications."
  },
  {
    "id": 53,
    "topic_id": 2,
    "title": "What are bots and what are botnets?",
    "description": "Bots are remotely controlled systems or devices that have a malware infection. Groups of bots are known as botnets, and botnets are used by attackers who control them to perform various actions ranging from additional compromises and infection to denial-of-service (DoS) attacks or acting as spam relays."
  },
  {
    "id": 54,
    "topic_id": 2,
    "title": "What are keyloggers?",
    "description": "Programs that capture keystrokes from keyboards, although keylogger applications may also capture other input like mouse movement, touchscreen inputs, or credit card swipes from attached devices."
  },
  {
    "id": 55,
    "topic_id": 2,
    "title": "What key element separates logic bombs from other malware?",
    "description": "Logic bombs are functions or code that are placed inside other programs that will activate when set conditions are met instead of independent malicious programs."
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "Name at least three types of viruses.",
    "description": "Memory-resident viruses, non-memory resident viruses, boot sector viruses, macro viruses, and email viruses."
  },
  {
    "id": 57,
    "topic_id": 2,
    "title": "Name at least five social engineering techniques.",
    "description": "Phishing, vishing, smishing, misinformation, disinformation, business email compromise, pretexting, watering hole attack, impersonation, brand impersonation, and typosquatting."
  },
  {
    "id": 58,
    "topic_id": 2,
    "title": "What is phishing?",
    "description": "Phishing is a broad term used to describe the fraudulent acquisition of information, often focused on credentials like usernames and passwords, as well as sensitive personal information like credit card numbers and related data."
  },
  {
    "id": 59,
    "topic_id": 2,
    "title": "Name three password-related attacks.",
    "description": "Brute-force attacks, password spraying attacks, and dictionary attacks."
  },
  {
    "id": 60,
    "topic_id": 5,
    "title": "What does the social engineering principle of authority rely on?",
    "description": "Authority relies on the fact that most people will obey someone who appears to be in charge or knowledgeable, regardless of whether or not they actually are."
  },
  {
    "id": 61,
    "topic_id": 5,
    "title": "What does the social engineering principle of intimidation rely on?",
    "description": "Intimidation relies on scaring or bullying an individual into taking a desired action."
  },
  {
    "id": 62,
    "topic_id": 5,
    "title": "What is the difference between misinformation and disinformation?",
    "description": "Misinformation is incorrect information, often resulting from getting facts wrong. Disinformation is incorrect, inaccurate, or outright false information that is intentionally provided to serve an individual or organization\u2019s goals."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "What is business email compromise?",
    "description": "Business email compromise (BEC) relies on using apparently legitimate email addresses to conduct scams and other attacks."
  },
  {
    "id": 64,
    "topic_id": 2,
    "title": "What do you call it when someone uses a made-up scenario to justify why they are approaching an individual?",
    "description": "Pretexting."
  },
  {
    "id": 65,
    "topic_id": 2,
    "title": "What term describes an attack where an attacker uses websites that targets frequent to attack them?",
    "description": "A watering hole attack."
  },
  {
    "id": 66,
    "topic_id": 2,
    "title": "What is brand impersonation?",
    "description": "An attack used in attempts to get users to log into their existing accounts, particularly for stores and banks."
  },
  {
    "id": 67,
    "topic_id": 2,
    "title": "What is typosquatting?",
    "description": "When attackers use misspelled and slightly off but similar to the legitimate site URLs and rely on the fact that people will mistype URLs and end up on their sites to drive up sales."
  },
  {
    "id": 68,
    "topic_id": 4,
    "title": "Name five\u00a0factors that influence how often an organization decides to conduct vulnerability scans against its systems.",
    "description": "Risk appetite, regulatory requirements, technical constraints, business constraints, licensing limitations."
  },
  {
    "id": 69,
    "topic_id": 1,
    "title": "Give some examples of controls that might affect scan results.",
    "description": "Firewall settings, network segmentation, intrusion detection systems (IDSs), intrusion prevention systems (IPSs)."
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "Name the three techniques used by application testing and explain their differences.",
    "description": "Static testing (analyzes code without executing it), dynamic testing (executes code as part of the test, running all the interfaces that the code exposes to the user with a variety of inputs, searching for vulnerabilities), and interactive testing (combines static and dynamic testing, analyzing the source code while testers interact with the application through exposed interfaces)."
  },
  {
    "id": 71,
    "topic_id": 4,
    "title": "What information does the output section provide on the report?",
    "description": "The output section of the report shows the detailed information returned by the remote system when probed for the vulnerability, including the name of the vulnerability, overall severity, detailed description, solution, references, port/hosts, vulnerability information, and risk information."
  },
  {
    "id": 72,
    "topic_id": 4,
    "title": "What information does the port/hosts section provide on the report?",
    "description": "The port/hosts section provides details on the server(s) that contain the vulnerability as well as the specific services on that server that have the vulnerability."
  },
  {
    "id": 73,
    "topic_id": 4,
    "title": "List all eight CVSS metrics and describe what kinds of measurements they evaluate.",
    "description": "The eight Common Vulnerability Scoring System (CVSS) metrics are attack vector metric, attack complexity metric, privileges required metric, user interaction metric, confidentiality metric, integrity metric, availability metric, and scope metric. The first four measures evaluate the exploitability of the vulnerability, whereas the next three evaluate the impact of the vulnerability. The eighth metric discusses the scope of the vulnerability."
  },
  {
    "id": 74,
    "topic_id": 4,
    "title": "What does the following CVSS vector mean? <code>CVSS:3.0/AV:N/AC:L/PR:N/UI:N/S:U/C:H/I:N/A:N</code>",
    "description": "Attack VectorNetwork (score0.85); Attack ComplexityLow (score0.77); Privileges RequiredNone (score0.85); User InteractionNone (score0.85); ScopeUnchanged; ConfidentialityHigh (score0.56); IntegrityNone (score0.00); AvailabilityNone (score0.00)."
  },
  {
    "id": 75,
    "topic_id": 5,
    "title": "What is the function to calculate the impact sub-score?",
    "description": "ISS = 1 \u2013 [(1 \u2013 Confidentiality)  (1 \u2013 Integrity)  (1 \u2013 Availability)]."
  },
  {
    "id": 76,
    "topic_id": 4,
    "title": "How do you calculate the impact score for a vulnerability under CVSS?",
    "description": "Impact score = the value of the scope metric * ISS."
  },
  {
    "id": 77,
    "topic_id": 4,
    "title": "How do you calculate the exploitability score for a vulnerability under CVSS?",
    "description": "Exploitability = 8.22 \u00d7 AttackVector \u00d7 AttackComplexity \u00d7 PrivilegesRequired \u00d7 UserInteraction."
  },
  {
    "id": 78,
    "topic_id": 4,
    "title": "How do you calculate the CVSS base score for a vulnerability?",
    "description": "<li>If the impact is 0, the base score is 0.</li>"
  },
  {
    "id": 79,
    "topic_id": 4,
    "title": "Explain true positive, false positive, true negative, and false negative",
    "description": "When a vulnerability scanner reports a vulnerability, this is known as a positive report. This report may either be accurate (a true positive report) or inaccurate (a false positive report). Similarly, when a scanner reports that a vulnerability is not present, this is a negative report. The negative report may either be accurate (a true negative report) or inaccurate (a false negative report)."
  },
  {
    "id": 80,
    "topic_id": 4,
    "title": "Give three valuable information sources for reconciling scan results.",
    "description": "Log reviews from servers, applications, network devices, and other sources that might contain information about possible attempts to exploit detected vulnerabilities; security information and event management (SIEM) systems that correlate log entries from multiple sources and provide actionable intelligence; and configuration management systems that provide information on the operating system and applications installed on a system."
  },
  {
    "id": 81,
    "topic_id": 2,
    "title": "Give some examples of weak configurations.",
    "description": "The use of default settings that pose a security risk; the presence of default credentials or unsecured accounts, including both normal user accounts and unsecured root accounts with administrative privileges; open ports and services that are not necessary to support normal system operations; and open permissions that allow users access that violates the principle of least privilege."
  },
  {
    "id": 82,
    "topic_id": 1,
    "title": "Name two choices you need to make when you implement encryption",
    "description": "The algorithm to use to perform encryption and decryption; the encryption key to use with that algorithm."
  },
  {
    "id": 83,
    "topic_id": 4,
    "title": "What are four major categories of penetration testing?",
    "description": "Physical penetration testing, offensive penetration testing, defensive penetration testing, and integrated penetration testing."
  },
  {
    "id": 84,
    "topic_id": 5,
    "title": "What are the benefits of penetration testing?",
    "description": "Penetration testing provides us with knowledge that we can\u2019t obtain elsewhere; in the event that attackers are successful, penetration testing provides us with an important blueprint for remediation; and penetration tests can provide us with essential, focused information on specific attack targets."
  },
  {
    "id": 85,
    "topic_id": 5,
    "title": "What are three typical classifications that are used to describe penetration test types?",
    "description": "Known environment, unknown environment, and partially known environment."
  },
  {
    "id": 86,
    "topic_id": 5,
    "title": "List at least three key elements of the rules of engagement for a penetration test.",
    "description": "The timeline for the engagement and when testing can be conducted; valid targets; data handling requirements; what behaviors to expect from the target; what resources are committed to the test; legal concerns should also be addressed, including a review of the laws that cover the target organization, any remote locations, and any service providers who will be in-scope, and when and how communications will occur."
  },
  {
    "id": 87,
    "topic_id": 4,
    "title": "Identify the four key phases of a penetration test.",
    "description": "Initial access, privilege escalation, pivoting (lateral movement), and persistence."
  },
  {
    "id": 88,
    "topic_id": 5,
    "title": "What are the three major components of a security assessment?",
    "description": "1Security tests, security assessments, and security audits."
  },
  {
    "id": 89,
    "topic_id": 1,
    "title": "Name the phases of the software development life cycle (SDLC).",
    "description": "Planning, requirements definition, design, coding, testing, training and transition, ongoing operations and maintenance, and end-of-life decommissioning."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "Name four code deployment environments.",
    "description": "Development environment, test environment, staging environment, and production environment."
  },
  {
    "id": 91,
    "topic_id": 2,
    "title": "What is the function of input validation?",
    "description": "Input validation helps prevent a wide range of problems, from cross-site scripting (XSS) to SQL injection (SQLi) attacks."
  },
  {
    "id": 92,
    "topic_id": 2,
    "title": "What is parameter pollution?",
    "description": "Parameter pollution is one technique that attackers have successfully used to defeat input validation controls."
  },
  {
    "id": 93,
    "topic_id": 2,
    "title": "What is the function of a web application firewall?",
    "description": "A web application firewall (WAF) plays an important role in protecting web applications against attacks. It sits in front of a web server and receives all network traffic headed to that server. It then scrutinizes the input headed to the application, performing input validation before passing the input to the web server."
  },
  {
    "id": 94,
    "topic_id": 1,
    "title": "Describe the continuous integration (CI) and continuous deployment (CD) pipeline.",
    "description": "Developer commits change, build process is triggered, build report is delivered, tests run against build, test report is delivered, and if successful, code is deployed."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "What are APIs?",
    "description": "Application programming interfaces (APIs) are interfaces between clients and servers or applications and operating systems that define how the client should ask for information from the server and how the server will respond."
  },
  {
    "id": 96,
    "topic_id": 2,
    "title": "Explain parameterized queries.",
    "description": "Parameterized queries offer another technique to protect applications against injection attacks."
  },
  {
    "id": 97,
    "topic_id": 2,
    "title": "What is sandboxing?",
    "description": "The practice of running an application in a controlled or isolated environment to prevent it from interacting negatively with other system resources or applications."
  },
  {
    "id": 98,
    "topic_id": 4,
    "title": "What is static code analysis and what is dynamic code analysis?",
    "description": "Static code analysis (sometimes called source code analysis) is conducted by reviewing the code for an application. Static analysis does not run the program, instead it focuses on understanding how the program is written and what the code is intended to do. Dynamic code analysis relies on execution of the code while providing it with input to test the software."
  },
  {
    "id": 99,
    "topic_id": 2,
    "title": "What does blind SQL injection (SQLi) mean and what are two forms of blind SQL injection?",
    "description": "Attackers use a technique called blind SQL injection to conduct an attack even when they don\u2019t have the ability to view the results directly. Two forms of blind SQL injection are content-based and timing-based."
  },
  {
    "id": 100,
    "topic_id": 2,
    "title": "Give three ways that an attacker might discover a user\u2019s password.",
    "description": "Conducting social engineering attacks that trick the user into revealing a password, either directly or through a false authentication mechanism; eavesdropping on unencrypted network traffic; and obtaining a dump of passwords from previously compromised sites and assuming that a significant number of users reuse their passwords from that site on other sites."
  },
  {
    "id": 101,
    "topic_id": 2,
    "title": "Give some ways that an attacker might obtain a cookie.",
    "description": "Eavesdropping on unencrypted network connections and stealing a copy of the cookie as it is transmitted between the user and the website; installing malware on the user\u2019s browser that retrieves cookies and transmits them back to the attacker, and engaging in an on-path attack, where the attacker fools the user into thinking that the attacker is actually the target website and presenting a fake authentication form. They may then authenticate to the website on the user\u2019s behalf and obtain the cookie."
  },
  {
    "id": 102,
    "topic_id": 2,
    "title": "What is insecure direct object reference?",
    "description": "If the application does not perform authorization checks, the user may be permitted to view information that exceeds their authority. This situation is known as an insecure direct object reference."
  },
  {
    "id": 103,
    "topic_id": 2,
    "title": "What are two variants that file inclusion attacks come in? How do they work?",
    "description": "Local file inclusion and remote file inclusion attacks. Local file inclusion attacks seek to execute code stored in a file located elsewhere on the web server. Remote file inclusion attacks allow the attacker to go a step further and execute code that is stored on a remote server."
  },
  {
    "id": 104,
    "topic_id": 2,
    "title": "When would cross-site scripting attacks occur?",
    "description": "Cross-site scripting (XSS) attacks occur when web applications allow an attacker to perform HTML injection, inserting their own HTML code into a web page."
  },
  {
    "id": 105,
    "topic_id": 2,
    "title": "What\u2019s the difference between cross-site scripting attacks and cross-site request forgery attacks?",
    "description": "They exploit a different trust relationship. XSS attacks exploit the trust that a user has in a website to execute code on the user\u2019s computer. XSRF attacks exploit the trust that remote sites have in a user\u2019s system to execute commands on the user\u2019s behalf."
  },
  {
    "id": 106,
    "topic_id": 1,
    "title": "How do developers provide a way to confirm the authenticity of their code to end users?",
    "description": "Through code signing. Developers digitally sign their code with their own private key and then browsers can use the developer\u2019s public key to verify that signature and ensure that the code is legitimate and was not modified by unauthorized individuals."
  },
  {
    "id": 107,
    "topic_id": 3,
    "title": "List and explain two principles we need to apply in application resilience.",
    "description": "<li>Scalability says that applications should be designed so that computing resources they require may be incrementally added to support increasing demand; elasticity goes a step further than scalability and says that applications should be able to automatically provision resources to scale when necessary and then automatically deprovision those resources to reduce capacity (and cost) when it is no longer needed.</li>"
  },
  {
    "id": 108,
    "topic_id": 2,
    "title": "What is resource exhaustion?",
    "description": "Resource exhaustion is when systems consume all of the memory, storage, processing time, or other resources available to them, rendering the system disabled or crippled for other uses."
  },
  {
    "id": 109,
    "topic_id": 1,
    "title": "What is a cipher?",
    "description": "A method used to scramble or obfuscate characters to hide their value. Ciphering is the process of using a cipher to do that type of scrambling to a message."
  },
  {
    "id": 110,
    "topic_id": 1,
    "title": "What is the substitution cipher?",
    "description": "A substitution cipher is a type of coding or ciphering system that changes one character or symbol into another."
  },
  {
    "id": 111,
    "topic_id": 1,
    "title": "What term is used to describe using cryptographic techniques to embed secret messages within another file, such as hiding a message within an image file?",
    "description": "Steganography is the art of using cryptographic techniques to embed secret messages within another file."
  },
  {
    "id": 112,
    "topic_id": 1,
    "title": "What are four fundamental goals of cryptography?",
    "description": "Confidentiality, integrity, authentication, and nonrepudiation."
  },
  {
    "id": 113,
    "topic_id": 1,
    "title": "What is the difference between symmetric and asymmetric cryptography?",
    "description": "Symmetric cryptosystems use a shared secret key available to all users of the cryptosystem.\u00a0Asymmetric cryptosystems use individual combinations of public and private keys for each user of the system."
  },
  {
    "id": 114,
    "topic_id": 1,
    "title": "What are three types of data we must think about when developing a cryptographic system for the purpose of providing confidentiality?",
    "description": "Data at rest, data in transit, data in use."
  },
  {
    "id": 115,
    "topic_id": 1,
    "title": "What are two major categories of modern ciphers and what are their methods of operation?",
    "description": "Block ciphers operate on \u201cchunks,\u201d or blocks, of a message and apply the encryption algorithm to an entire message block at the same time. Stream ciphers operate on one character or bit of a message (or data stream) at a time."
  },
  {
    "id": 116,
    "topic_id": 1,
    "title": "List some weaknesses of symmetric key cryptography.",
    "description": "Key exchange is a major problem; symmetric key cryptography does not implement nonrepudiation; the algorithm is not scalable; and keys must be regenerated often."
  },
  {
    "id": 117,
    "topic_id": 1,
    "title": "List some major strengths of asymmetric key cryptography.",
    "description": "The addition of new users requires the generation of only one public-private key pair; users can be removed far more easily from asymmetric systems; key regeneration is required only when a user\u2019s private key is compromised; asymmetric key encryption can provide integrity, authentication, and nonrepudiation; key distribution is a simple process; and no preexisting communication link needs to exist."
  },
  {
    "id": 118,
    "topic_id": 1,
    "title": "What is frequency analysis?",
    "description": "Frequency analysis involves looking at the blocks of an encrypted message to determine if any common patterns exist."
  },
  {
    "id": 119,
    "topic_id": 1,
    "title": "What is homomorphic encryption?",
    "description": "Homomorphic encryption technology allows encrypting data in a way that preserves the ability to perform computation on that data."
  },
  {
    "id": 120,
    "topic_id": 1,
    "title": "What are three key lengths allowed by the AES cipher and what are their corresponding number of encryption rounds?",
    "description": "128-bit keys require 10 rounds of encryption; 192-bit keys require 12 rounds of encryption; and 256-bit keys require 14 rounds of encryption."
  },
  {
    "id": 121,
    "topic_id": 1,
    "title": "What are three main methods used to exchange secret keys securely?",
    "description": "Offline distribution, public key encryption, and the Diffie\u2013Hellman key exchange algorithm."
  },
  {
    "id": 122,
    "topic_id": 1,
    "title": "What are five basic requirements for a cryptographic hash function?",
    "description": "They accept an input of any length; they produce an output of a fixed length; the hash value is relatively easy to compute; the hash function is one-way (meaning that it is extremely hard to determine the input when provided with the output); and the hash function is collision free (meaning that it is extremely hard to find two messages that produce the same hash value)."
  },
  {
    "id": 123,
    "topic_id": 1,
    "title": "What are two distinct goals of digital signature infrastructure?",
    "description": "Digitally signed messages assure the recipient that the message truly came from the claimed sender. They enforce nonrepudiation. Digitally signed messages assure the recipient that the message was not altered while in transit between the sender and recipient. This protects against both malicious modification and unintentional modification."
  },
  {
    "id": 124,
    "topic_id": 1,
    "title": "What are some of the attributes used in an X.509 certificate?",
    "description": "Version of X.509; serial number; signature algorithm identifier; issuer name; validity period; subject\u2019s Common Name (CN); certificates may optionally contain Subject Alternative Names (SAN) that allow you to specify additional items (IP addresses, domain names, and so on) to be protected by the single certificate; and subject\u2019s public key."
  },
  {
    "id": 125,
    "topic_id": 1,
    "title": "Why might a certificate authority need to revoke a digital certificate?",
    "description": "The certificate was compromised (e.g., the certificate owner accidentally gave away the private key); the certificate was erroneously issued (e.g., the CA mistakenly issued a certificate without proper verification); the details of the certificate changed (e.g., the subject\u2019s name changed); and the security association changed (e.g., the subject is no longer employed by the organization sponsoring the certificate)."
  },
  {
    "id": 126,
    "topic_id": 1,
    "title": "What are three techniques to verify the authenticity of certificates and identify revoked certificates?",
    "description": "Certificate revocation lists (CRLs), Online Certificate Status Protocol (OCSP), and certificate stapling."
  },
  {
    "id": 127,
    "topic_id": 4,
    "title": "List five common ways to assert or claim an identity.",
    "description": "Usernames, certificates, tokens, SSH keys, and smart cards."
  },
  {
    "id": 128,
    "topic_id": 4,
    "title": "Name at least three authentication technologies.",
    "description": "Extensible Authentication Protocol (EAP), Challenge Handshake Authentication Protocol (CHAP), Password Authentication Protocol (PAP), 802.1X, Remote Authentication Dial-In User Service (RADIUS), Terminal Access Controller Access Control System Plus (TACACS+), and Kerberos."
  },
  {
    "id": 129,
    "topic_id": 4,
    "title": "What is SAML?",
    "description": "Security Assertions Markup Language (SAML) is an XML-based open standard for exchanging authentication and authorization information."
  },
  {
    "id": 130,
    "topic_id": 4,
    "title": "What does an SSO system allow?",
    "description": "Single sign-on (SSO) systems allow a user to log in with a single identity, and then use multiple systems or services without reauthenticating."
  },
  {
    "id": 131,
    "topic_id": 4,
    "title": "List four types of factors in multifactor authentication and explain them.",
    "description": "Something you know, including passwords, PINs, or the answer to a security question; something you have, like a smartcard or token; something you are, which relies on a physical characteristic of the person who is authenticating themselves; and somewhere you are, sometimes called a location factor, is based on your current location. Location can be detected with GPS technology or viewing IP address information."
  },
  {
    "id": 132,
    "topic_id": 1,
    "title": "What are two primary models for generation of one-time passwords?",
    "description": "TOTP, or time-based one-time passwords and HMAC-based one-time password (HOTP)."
  },
  {
    "id": 133,
    "topic_id": 4,
    "title": "List three common biometric technologies.",
    "description": "Fingerprints, retina scanning, iris recognition; facial recognition; voice recognition; vein recognition, and gait analysis."
  },
  {
    "id": 134,
    "topic_id": 1,
    "title": "What are password vaults?",
    "description": "Software solutions that store, manage, and secure passwords and other information, allowing users to use strong passwords without memorizing dozens, or hundreds, of individual complex passwords."
  },
  {
    "id": 135,
    "topic_id": 4,
    "title": "List common account types used for Windows systems.",
    "description": "User accounts; privileged or administrative accounts; shared and generic accounts or credentials; guest accounts; and service accounts associated with applications and services."
  },
  {
    "id": 136,
    "topic_id": 4,
    "title": "List and explain all three primary rules of role-based access control (RBAC).",
    "description": "Role assignment, which states that subjects can use only permissions that match a role they have been assigned; role authorization, which states that the subject\u2019s active role must be authorized for the subject\u2014this prevents subjects from taking on roles they shouldn\u2019t be able to; and permission authorization, which states that subjects can only use permissions that their active role is allowed to use."
  },
  {
    "id": 137,
    "topic_id": 4,
    "title": "Name five common access control schemes.",
    "description": "Attribute-based access control (ABAC), role-based access control (RBAC), rule-based access control (RBAC or RuBAC), mandatory access control (MAC), and discretionary access control (DAC)."
  },
  {
    "id": 138,
    "topic_id": 4,
    "title": "What are filesystem permissions?",
    "description": "They determine which accounts, users, groups, or services can perform actions like reading, writing, and executing (running) files."
  },
  {
    "id": 139,
    "topic_id": 3,
    "title": "List three common elements in designs for redundancy.",
    "description": "Geographic dispersion of systems, separation of servers and other devices in datacenters, use of multiple network paths (multipath) solutions, redundant network devices, protection of power, systems and storage redundancy, and platform diversity."
  },
  {
    "id": 140,
    "topic_id": 3,
    "title": "List at least three backup and replication methods.",
    "description": "RAID, journaling, full and incremental backups, snapshots, images, copies of individual files, backup media, cloud backups, and off-site or on-site storage."
  },
  {
    "id": 141,
    "topic_id": 3,
    "title": "What is RAID 5 and what are its advantages and disadvantages?",
    "description": "RAID 5 is a solution in which data is striped across drives, with one drive used for parity (checksum) of the data. Parity is spread across drives as well as data. RAID 5\u2019s advantages are that data reads are fast; drive failures can be rebuilt as long as only one drive fails. RAID 5\u2019s disadvantages are that it can only tolerate a single drive failure at a time, data writes are slightly slower, and rebuilding arrays after a drive loss can be slow and impact performance."
  },
  {
    "id": 142,
    "topic_id": 3,
    "title": "Give four important considerations that come into play with cloud and off-site third-party backup options.",
    "description": "Bandwidth requirements for both the backups themselves and restoration time if the backup needs to be restored partially or fully; time to retrieve files and cost to retrieve files; reliability is also crucial; and new security models may also be required for backups."
  },
  {
    "id": 143,
    "topic_id": 3,
    "title": "List and explain two categories of scalability and their advantages.",
    "description": "Vertical scalability uses a more capable system or device and helps when all tasks or functions need to be handled on the same system or infrastructure. Horizontal scaling uses more smaller systems or devices. A horizontally scaled system can take advantage of the ability to transparently add and remove more resources, allowing it to adjust as needs grow or shrink and allows opportunities for transparent upgrades, patching, and even incident response."
  },
  {
    "id": 144,
    "topic_id": 3,
    "title": "What are three major types of disaster recovery sites used for site resilience?",
    "description": "Hot sites, warm sites, and cold sites."
  },
  {
    "id": 145,
    "topic_id": 3,
    "title": "List all steps in site restoration.",
    "description": "Restore network connectivity and a bastion or shell host; restore network security devices (firewalls, IPS); restore storage and database services; restore critical operational servers; restore logging and monitoring service; and restore other services as soon as possible."
  },
  {
    "id": 146,
    "topic_id": 1,
    "title": "What is a bollard?",
    "description": "Bollards are posts or other obstacles that prevent vehicles from moving through an area. Bollards may look like posts, pillars, or even planters, but their purpose remains the same: preventing vehicle access."
  },
  {
    "id": 147,
    "topic_id": 1,
    "title": "What is an access control vestibule?",
    "description": "An access control vestibule is a pair of doors that both require some form of authorized access to open. The first door opens after authorization, closes, and only after it is closed can the person who wants to enter provide their authorization to open the second door."
  },
  {
    "id": 148,
    "topic_id": 1,
    "title": "What are the advantages of guards?",
    "description": "Guards can make decisions that technical control systems cannot, and they provide additional capabilities by offering both detection and response capabilities. Guards can validate an individual\u2019s identity, ensure that they enter only the areas they are supposed to, and ensure that they have signed a visitor log and that their signature matches a signature on file or on their ID card."
  },
  {
    "id": 149,
    "topic_id": 1,
    "title": "What are the disadvantages of guards?",
    "description": "Guards can be fallible, and social engineering attempts can persuade guards to violate policies or even to provide attackers with assistance. Guards are relatively expensive."
  },
  {
    "id": 150,
    "topic_id": 4,
    "title": "What are two types of advanced security camera capabilities?",
    "description": "Motion recognition and object detection."
  },
  {
    "id": 151,
    "topic_id": 5,
    "title": "What are three areas for capacity planning?",
    "description": "Three areas for capacity planning are people, technology, and infrastructure."
  },
  {
    "id": 152,
    "topic_id": 3,
    "title": "What are four common methods of testing resilience and recovery controls?",
    "description": "Tabletop exercises, simulation exercises, parallel processing, and failover exercises."
  },
  {
    "id": 153,
    "topic_id": 1,
    "title": "What are infrared sensors?",
    "description": "They rely on infrared light, or heat radiation. They look for changes in infrared radiation in a room or space and alert when that change occurs."
  },
  {
    "id": 154,
    "topic_id": 1,
    "title": "What are pressure sensors?",
    "description": "They detect a change in pressure. While not commonly deployed in most environments, they may be used when an organization needs to detect an object being moved or when someone is moving through an area using a pressure plate or pad."
  },
  {
    "id": 155,
    "topic_id": 1,
    "title": "What are microwave sensors?",
    "description": "Microwave sensors use a baseline for a room or space that is generated by detecting normal responses when the space is at a baseline. When those responses to the microwaves sent out by the sensor change, they will trigger. They can detect motion through materials that infrared sensors cannot."
  },
  {
    "id": 156,
    "topic_id": 2,
    "title": "Describe how RFID cloning attacks work.",
    "description": "RFID cloning attacks work by cloning an RFID tag or card."
  },
  {
    "id": 157,
    "topic_id": 2,
    "title": "How do environmental attacks work?",
    "description": "Environmental attacks include attacks like targeting an organization\u2019s heating and cooling systems, maliciously activating a sprinkler system, and similar actions."
  },
  {
    "id": 158,
    "topic_id": 3,
    "title": "What is cloud computing?",
    "description": "A model for enabling ubiquitous, convenient, on-demand network access to a shared pool of configurable computing resources (e.g., networks, servers, storage, applications, and services) that can be rapidly provisioned and released with minimal management effort or service provider interaction."
  },
  {
    "id": 159,
    "topic_id": 3,
    "title": "What are the key benefits of the cloud?",
    "description": "On-demand self-service computing, scalability, elasticity, measured service, agility and flexibility."
  },
  {
    "id": 160,
    "topic_id": 5,
    "title": "List and explain the five key cloud roles.",
    "description": "Cloud service providers offer cloud computing services; cloud consumers purchase cloud services from cloud service providers; cloud partners and brokers offer ancillary products that support or integrate with the offerings of a cloud service provider; cloud auditors are independent organizations that provide assessments of cloud services and operations; cloud carriers serve provide connectivity that allows the delivery of cloud services from providers to consumers."
  },
  {
    "id": 161,
    "topic_id": 3,
    "title": "What are three major cloud service models?",
    "description": "Infrastructure as a service (IaaS), software as a service (SaaS), and platform as a service (PaaS)."
  },
  {
    "id": 162,
    "topic_id": 3,
    "title": "List the four cloud deployment models.",
    "description": "Public cloud, private cloud, community cloud, and hybrid cloud."
  },
  {
    "id": 163,
    "topic_id": 3,
    "title": "What is the primary responsibility of the hypervisor?",
    "description": "The primary responsibility of the hypervisor is enforcing <i>isolation</i> between virtual machines.\u00a0This means that the hypervisor must present each virtual machine with the illusion of a completely separate physical environment dedicated for use by that virtual machine."
  },
  {
    "id": 164,
    "topic_id": 3,
    "title": "What are two primary types of hypervisors and what are their differences?",
    "description": "Type I hypervisors, also known as bare-metal hypervisors, operate directly on top of the underlying hardware. This is the model most commonly used in datacenter virtualization because it is highly efficient. Type II hypervisors run as an application on top of an existing operating system. In this approach, the operating system supports the hypervisor and the hypervisor requests resources for each guest operating system from the host operating system."
  },
  {
    "id": 165,
    "topic_id": 3,
    "title": "What are two categories of cloud storage offerings?",
    "description": "Block storage allocates large volumes of storage for use by virtual server instance(s). Object storage provides customers with the ability to place files in buckets and treat each file as an independent entity that may be accessed over the web or through the provider\u2019s API."
  },
  {
    "id": 166,
    "topic_id": 3,
    "title": "What are three key security considerations when working with cloud storage?",
    "description": "Set permissions properly; consider high availability and durability options; and use encryption to protect sensitive data."
  },
  {
    "id": 167,
    "topic_id": 3,
    "title": "What principle states that data is subject to the legal restrictions of any jurisdiction where it is collected, stored, or processed?",
    "description": "Data sovereignty is a principle that states that data is subject to the legal restrictions of any jurisdiction where it is collected, stored, or processed."
  },
  {
    "id": 168,
    "topic_id": 1,
    "title": "What are two different approaches to cloud access security broker (CASB) solutions?",
    "description": "Inline CASB solutions physically or logically reside in the connection path between the user and the service and can see requests before they are sent to the cloud service, allowing the CASB to block requests that violate policy. API-based CASB solutions do not interact directly with the user but rather interact directly with the cloud provider through the provider\u2019s API. This approach provides direct access to the cloud service without custom user device configuration."
  },
  {
    "id": 169,
    "topic_id": 5,
    "title": "What term describes an organization that offers services such as security monitoring, vulnerability management, incident response, and firewall management?",
    "description": "Managed security service provider (MSSP)."
  },
  {
    "id": 170,
    "topic_id": 3,
    "title": "What provides application-level virtualization?",
    "description": "A container."
  },
  {
    "id": 171,
    "topic_id": 3,
    "title": "What allows engineers to interact with and modify cloud resources through their APIs?",
    "description": "Software-defined networking (SDN)."
  },
  {
    "id": 172,
    "topic_id": 4,
    "title": "What provides cybersecurity professionals with insight into the traffic on their virtual networks?",
    "description": "Software-defined visibility (SDV)."
  },
  {
    "id": 173,
    "topic_id": 1,
    "title": "What is the function of security groups?",
    "description": "They define permissible network traffic."
  },
  {
    "id": 174,
    "topic_id": 1,
    "title": "What is the function of segmentation?",
    "description": "It allows network engineers to place systems of differing security levels and functions on different network subnets."
  },
  {
    "id": 175,
    "topic_id": 3,
    "title": "What is the function of virtual private clouds?",
    "description": "VPCs are used to group systems into subnets and designate those subnets as public or private, depending on whether access to them is permitted from the Internet."
  },
  {
    "id": 176,
    "topic_id": 1,
    "title": "What is the function of a hardware security module (HSM)?",
    "description": "HSMs manage encryption keys and perform cryptographic operations efficiently."
  },
  {
    "id": 177,
    "topic_id": 4,
    "title": "What are two different techniques to ensure that the system is secure that modern UEFI firmware can leverage?",
    "description": "Secure boot ensures that the system boots using only software that the original equipment manufacturer (OEM) trusts. Measured boot is intended to help prevent boot-level malware. Measured boot processes measure each component, starting with the firmware and ending with the boot start drivers."
  },
  {
    "id": 178,
    "topic_id": 4,
    "title": "List four common methods to detect malicious software and applications.",
    "description": "Signature-based detection; heuristic or behavior-based detection; artificial intelligence (AI) and machine learning (ML) systems; and sandboxing."
  },
  {
    "id": 179,
    "topic_id": 1,
    "title": "What are allow and deny lists?",
    "description": "An allow list allows you to build a list of software, applications, and other system components that are allowed to exist and run on a system. If they are not on the allow list, they will be removed, disabled, or will not be able to be installed. Deny lists are lists of software or applications that cannot be installed or run, rather than a list of what is allowed."
  },
  {
    "id": 180,
    "topic_id": 4,
    "title": "Give some types of configuration settings recommended by CIS benchmark for Windows.",
    "description": "Setting the password history to remember 24 or more passwords and setting maximum passwords age to \u201c60 or fewer days, but not 0,\u201d preventing users from simply changing their passwords 24 times to get back to the same password while requiring password changes every 2 months. Setting the minimum password length to 14 or more characters. Requiring password complexity. Disabling the storage of passwords using reversible encryption."
  },
  {
    "id": 181,
    "topic_id": 1,
    "title": "How does FDE work?",
    "description": "Full disk encryption (FDE) encrypts the disk and requires that the bootloader or a hardware device provide a decryption key and software or hardware to decrypt the drive for use."
  },
  {
    "id": 182,
    "topic_id": 1,
    "title": "What kinds of potential downfalls does disk encryption bring?",
    "description": "If the encryption key is lost, the data on the drive will likely be unrecoverable since the same strong encryption that protects it will make it unlikely that you will be able to brute-force the key and acquire the data. Technical support can be more challenging, and data corruption or other issues can have a larger impact, resulting in unrecoverable data."
  },
  {
    "id": 183,
    "topic_id": 4,
    "title": "What steps can be used to assess embedded systems?",
    "description": "Identify the manufacturer Determine how the embedded system interfaces with the world: Identify services and their security."
  },
  {
    "id": 184,
    "topic_id": 2,
    "title": "What kinds of issues should security analysts be aware of when dealing with IoT devices?",
    "description": "Poor security practices including weak default settings, lack of network security (firewalls), exposed or vulnerable services, lack of encryption for data transfer, weak authentication, use of embedded credentials and\u00a0insecure data storage; Short support lifespans; Vendor data handling practice issues."
  },
  {
    "id": 185,
    "topic_id": 3,
    "title": "What security constraints do you need to take into account when you consider security for embedded systems?",
    "description": "The overall computational power and capacity of embedded systems is usually much lower than a traditional PC or mobile device; embedded systems may not connect to a network; without network connectivity, CPU and memory capacity, and other elements, authentication is also likely to be impossible; and embedded systems may be very low cost, but many are effectively very high cost because they are a component in a larger industrial or specialized device."
  },
  {
    "id": 186,
    "topic_id": 1,
    "title": "What are three major functions provided by TPM chips?",
    "description": "Trusted Platform Module (TPM) chips are frequently used to provide built-in encryption, and they provide three major functions: remote attestation, allowing hardware and software configurations to be verified; binding, which encrypts data; and sealing, which encrypts data and sets requirements for the state of the TPM chip before decryption."
  },
  {
    "id": 187,
    "topic_id": 1,
    "title": "What are HSMs?",
    "description": "Hardware security modules (HSMs) are typically external devices or plug-in cards used to create, store, and manage digital keys for cryptographic functions and authentication, as well as to offload cryptographic processing."
  },
  {
    "id": 188,
    "topic_id": 1,
    "title": "What are cryptographic key management systems used for?",
    "description": "Cryptographic key management systems are used to store keys and certificates as well as to manage them centrally."
  },
  {
    "id": 189,
    "topic_id": 4,
    "title": "Describe EDR.",
    "description": "Endpoint detection and response (EDR) tools combine monitoring capabilities on endpoint devices and systems using a client or software agent with network monitoring and log analysis capabilities to collect, correlate, and analyze events. Key features of EDR systems are the ability to search and explore the collected data and to use it for investigations as well as the ability to detect suspicious data."
  },
  {
    "id": 190,
    "topic_id": 3,
    "title": "Describe key elements of DLP.",
    "description": "Key elements of data loss prevention (DLP) systems are the ability to classify data so that organizations know which data should be protected; data labeling or tagging functions, to support classification and management practices; policy management and enforcement functions used to manage data to the standards set by the organization; and monitoring and reporting capabilities, to quickly notify administrators or security practitioners about issues or potential problems."
  },
  {
    "id": 191,
    "topic_id": 1,
    "title": "Name three endpoint protection solutions.",
    "description": "Host-based firewall, host intrusion prevention system (HIPS), and host intrusion detection system (HIDS)."
  },
  {
    "id": 192,
    "topic_id": 2,
    "title": "What is one of the fastest ways to decrease the attack surface of a system?",
    "description": "Reducing the number of open ports and services that it provides by disabling ports and protocols."
  },
  {
    "id": 193,
    "topic_id": 2,
    "title": "What are a few network hardening techniques?",
    "description": "The use of VLANs to segment different trust levels, user groups, or systems; placing IoT devices on a separate, protected VLAN; using a VLAN for guest networks or to isolate VoIP phones from workstations; changing default passwords; and removing unnecessary software."
  },
  {
    "id": 194,
    "topic_id": 1,
    "title": "What are three phases of a baseline\u2019s life cycle?",
    "description": "Establishing a baseline, deploying the security baseline, and maintaining the baseline."
  },
  {
    "id": 195,
    "topic_id": 3,
    "title": "How does network segmentation work?",
    "description": "It divides a network up into logical or physical groupings that are frequently based on trust boundaries, functional requirements, or other reasons that help an organization apply controls or assist with functionality."
  },
  {
    "id": 196,
    "topic_id": 1,
    "title": "What are two common NAC usage models?",
    "description": "Network access control (NAC) can use a software agent that is installed on the computer to perform security checks, or it may be agentless and run from a browser or via another means without installing software locally."
  },
  {
    "id": 197,
    "topic_id": 1,
    "title": "What is port security?",
    "description": "A capability that allows you to limit the number of MAC addresses that can be used on a single port."
  },
  {
    "id": 198,
    "topic_id": 2,
    "title": "List four types of protocol-level protections.",
    "description": "Loop prevention, broadcast storm prevention, bridge protocol data unit (BPDU) guard, and Dynamic Host Configuration Protocol (DHCP) snooping."
  },
  {
    "id": 199,
    "topic_id": 4,
    "title": "What are port mirrors and a SPAN?",
    "description": "A port mirror sends a copy of all the traffic sent to one switch port to another switch port for monitoring. A SPAN can do the same thing but can also combine traffic from multiple ports to a single port for analysis."
  },
  {
    "id": 200,
    "topic_id": 1,
    "title": "What is a VPN?",
    "description": "A virtual private network (VPN) is a way to create a virtual network link across a public network that allows the endpoints to act as though they are on the same network."
  },
  {
    "id": 201,
    "topic_id": 3,
    "title": "What are two decision points for VPN implementation?",
    "description": "Whether the VPN will be used for remote access, or if it will be a site-to-site VPN; and whether they will be a split-tunnel VPN or a full-tunnel VPN."
  },
  {
    "id": 202,
    "topic_id": 3,
    "title": "Explain active/active vs. active/passive load balancers.",
    "description": "Active/active load balancer designs distribute the load among multiple systems that are online and in use at the same time.\u00a0Active/passive load balancer designs bring backup or secondary systems online when an active system is removed or fails to respond properly to a health check."
  },
  {
    "id": 203,
    "topic_id": 3,
    "title": "What are two types of proxy servers?",
    "description": "Forward proxies are placed between clients and servers, and they accept requests from clients and send them forward to servers. Reverse proxies are placed between servers and clients, and they are used to help with load balancing and caching of content."
  },
  {
    "id": 204,
    "topic_id": 4,
    "title": "What are the three common detection methods to identify unwanted and potentially malicious traffic?",
    "description": "Signature-based detections rely on a known hash or signature matching to detect a threat.\u00a0Heuristic or behavior-based detections look for specific patterns or sets of actions that match threat behaviors. Anomaly-based detections establish a baseline for an organization or network and then flags when out-of-the-ordinary behavior occurs."
  },
  {
    "id": 205,
    "topic_id": 1,
    "title": "What are the differences between stateless firewalls and stateful firewalls?",
    "description": "Stateless firewalls (sometimes called packet filters) filter every packet based on data like the source and destination IP and port, the protocol, and other information that can be gleaned from the packet\u2019s headers, whereas stateful firewalls (sometimes called dynamic packet filters) pay attention to the state of traffic between systems."
  },
  {
    "id": 206,
    "topic_id": 1,
    "title": "What are web application firewalls?",
    "description": "Security devices that are designed to be able to intercept, analyze, and apply rules to web traffic, including tools like database queries, APIs, and other web application tools."
  },
  {
    "id": 207,
    "topic_id": 4,
    "title": "What are four types of information-gathering tools included in the Security+ exam outline?",
    "description": "Honeypots are configured to appear to be vulnerable and are heavily instrumented to record what an attacker does. Honeynets are networks set up to collect information about network attacks. A honeyfile is an intentionally attractive file that contains unique, detectable data that is left in an area for attackers to take. Honeytokens are data intended to be attractive to attackers used to allow security professionals to track data."
  },
  {
    "id": 208,
    "topic_id": 2,
    "title": "What is an on-path attack?",
    "description": "Occurs when an attacker causes traffic that should be sent to its intended recipient to be relayed through a system or device the attacker controls."
  },
  {
    "id": 209,
    "topic_id": 2,
    "title": "Which term describes the points at which an unauthorized user could gain access?",
    "description": "Attack surface."
  },
  {
    "id": 210,
    "topic_id": 1,
    "title": "What are security zones?",
    "description": "Network segments, physical or virtual network segments, or other components of an infrastructure that are able to be separate from less secure zones through logical or physical means."
  },
  {
    "id": 211,
    "topic_id": 3,
    "title": "What is SDN?",
    "description": "Software-defined networking (SDN) uses software-based network configuration to control networks. SDN designs rely on controllers that manage network devices and configurations, centrally managing the software-defined network."
  },
  {
    "id": 212,
    "topic_id": 3,
    "title": "Describe SASE.",
    "description": "Secure access service edge (SASE) combines VPNs, SD-WAN, and cloud-based security tools like firewalls, CASBs, and zero-trust networks to provide secure access for devices regardless of their location."
  },
  {
    "id": 213,
    "topic_id": 3,
    "title": "Describe how zero trust works.",
    "description": "Zero trust presumes that there is no trust boundary and no network edge. Each action is validated when requested as part of a continuous authentication process and access is only allowed after policies are checked, including elements like identity, permissions, system configuration and security status, threat intelligence data review, and security posture."
  },
  {
    "id": 214,
    "topic_id": 3,
    "title": "What do administrators use as a way to securely operate in security zones with different security levels?",
    "description": "Jump servers."
  },
  {
    "id": 215,
    "topic_id": 1,
    "title": "Describe the functions of DKIM, SPF, and DMARC in protecting email.",
    "description": "DomainKeys Identified Mail (DKIM) allows organizations to add content to messages to identify them as being from their domain. Sender Policy Framework (SPF) allows organizations to publish a list of their authorized email servers. SPF records specify which systems are allowed to send email from that domain. Domain-based Message Authentication, Reporting and Conformance (DMARC) is a protocol that uses SPF and DKIM to determine if an email message is authentic."
  },
  {
    "id": 216,
    "topic_id": 2,
    "title": "List at least five connectivity methods.",
    "description": "Cellular, Wi-Fi, Bluetooth, NFC, RFID, Infrared, GPS, USB."
  },
  {
    "id": 217,
    "topic_id": 1,
    "title": "What is NFC and how is it most frequently used?",
    "description": "NFC, or near-field communication, is used for very short range communication between devices. You\u2019ve likely seen NFC used for payment terminals using Apple Pay or Google Wallet using cell phones. NFC is limited to short range, meaning that it is not used to build networks of devices, and instead it is primarily used for low bandwidth, device to device purposes."
  },
  {
    "id": 218,
    "topic_id": 1,
    "title": "What is RFID?",
    "description": "RFID (Radio Frequency Identification) is a relatively short range (from less than a foot of some passive tags to about 100 meters for active tags) wireless technology that uses a tag and a receiver to exchange information."
  },
  {
    "id": 219,
    "topic_id": 2,
    "title": "What is an evil twin?",
    "description": "A malicious fake access point that is set up to appear to be a legitimate, trusted network."
  },
  {
    "id": 220,
    "topic_id": 2,
    "title": "What are two types of Bluetooth attacks and what are their differences?",
    "description": "Bluejacking sends unsolicited messages to Bluetooth-enabled devices. Bluesnarfing is unauthorized access to a Bluetooth device, typically aimed at gathering information like contact lists or other details the device contains."
  },
  {
    "id": 221,
    "topic_id": 4,
    "title": "What are two major usage modes provided by WPA3?",
    "description": "WPA-Personal uses Simultaneous Authentication of Equals (SAE) mode to provide authentication while protecting against offline dictionary attacks. This allows clients to authenticate without an authentication server infrastructure. The other is WPA-Enterprise, which relies on a RADIUS authentication server as part of an 802.1X implementation for authentication. This means users can have unique credentials and can be individually identified."
  },
  {
    "id": 222,
    "topic_id": 4,
    "title": "List and explain three major types of authentication in modern Wi-Fi networks.",
    "description": "Open networks do not require authentication or use encryption and\u00a0often use a captive portal to information from users. Preshared keys (PSK) require that a passphrase or key is shared with anybody who wants to use the network and provides encryption. Enterprise authentication relies on a RADIUS server and utilizes an EAP protocol for authentication."
  },
  {
    "id": 223,
    "topic_id": 4,
    "title": "Name four common mobile device deployment and management models.",
    "description": "BYOD (bring your own device), CYOD (choose your own device) COPE (Corporate owned, personally enabled), and corporate owned."
  },
  {
    "id": 224,
    "topic_id": 4,
    "title": "Give three examples of features that an organization may want or need to ensure that mobile devices and the data they contain are secure.",
    "description": "Application management Content management. Remote wipe Geolocation and geofencing Screen locks, passwords, and PINs are all part of normal device security models to prevent unauthorized access. Biometrics Context-aware authentication Containerization is an increasingly common solution to handling separation of work and personal use contexts on devices. Storage segmentation can be used to keep personal and business data separate as well. Full-device encryption (FDE)."
  },
  {
    "id": 225,
    "topic_id": 3,
    "title": "How do organizations determine where to place access points to handle poor coverage areas?",
    "description": "They conduct site surveys and create heat maps showing where coverage is relative to existing access points."
  },
  {
    "id": 226,
    "topic_id": 4,
    "title": "Organizations that want to determine what software and configurations are used on mobile devices should deploy what type of solution?",
    "description": "Mobile device management (MDM)."
  },
  {
    "id": 227,
    "topic_id": 4,
    "title": "What are six steps in the incident response process?",
    "description": "Preparation, identification, containment, eradication, recovery, and lessons learned."
  },
  {
    "id": 228,
    "topic_id": 4,
    "title": "Who are the typical team members in an incident response team?",
    "description": "Members of management or organizational leadership, technical experts, communications and public relations staff, legal and human relations staff, law enforcement."
  },
  {
    "id": 229,
    "topic_id": 4,
    "title": "What are the three major types of exercises that incident response teams use to prepare?",
    "description": "Tabletop, walkthroughs, simulations."
  },
  {
    "id": 230,
    "topic_id": 4,
    "title": "List four incident response plan types.",
    "description": "Communication plans, stakeholder management plans, business continuity plans, and disaster recovery plans."
  },
  {
    "id": 231,
    "topic_id": 4,
    "title": "Name seven elements in the security information and event management system.",
    "description": "SIEM dashboard, sensors, sensitivity and threshold, trends, alerts and alarms, correlation and analysis, rules."
  },
  {
    "id": 232,
    "topic_id": 4,
    "title": "List 5 common logs used by incident responders.",
    "description": "System logs, application logs, security logs, vulnerability scan output, network and security device logs, web logs, DNS logs, authentication logs, dump files, and VoIP and SIP logs."
  },
  {
    "id": 233,
    "topic_id": 4,
    "title": "What are playbooks?",
    "description": "Step-by-step guides intended to help incident response teams take the right steps in a given scenario."
  },
  {
    "id": 234,
    "topic_id": 4,
    "title": "What are runbooks?",
    "description": "The operational procedures guides that organizations use to perform actions."
  },
  {
    "id": 235,
    "topic_id": 2,
    "title": "List three techniques that support removing systems, devices, or even entire network segments or zones.",
    "description": "Isolation, containment, segmentation."
  },
  {
    "id": 236,
    "topic_id": 4,
    "title": "What type of testing involves discussing what a staff member would do in a given scenario?",
    "description": "Tabletop exercises leverage discussions and conversations to help organizations prepare for actual events."
  },
  {
    "id": 237,
    "topic_id": 4,
    "title": "After an event or incident, what process is used to determine why it occurred?",
    "description": "Root cause analysis is used to determine why an event or issue occurred."
  },
  {
    "id": 238,
    "topic_id": 5,
    "title": "What are 9 stages in the EDRM model?",
    "description": "Information governance."
  },
  {
    "id": 239,
    "topic_id": 4,
    "title": "List the order of volatility",
    "description": "From most volatile to least volatile:."
  },
  {
    "id": 240,
    "topic_id": 5,
    "title": "What is a right-to-audit clause?",
    "description": "Part of the contract between cloud service and an organization. A right-to-audit clause provides either a direct ability to audit the cloud provider or an agreement to use a third-party audit agency."
  },
  {
    "id": 241,
    "topic_id": 4,
    "title": "What is the Linux dd command? Give an example to copy a drive mounted as /dev/sda to a file called example.img.",
    "description": "The Linux dd command is a command-line utility that allows you to create disk images for forensic or other purposes."
  },
  {
    "id": 242,
    "topic_id": 4,
    "title": "What are common elements in a typical forensic report?",
    "description": "A summary of the forensic investigation and findings; an outline of the forensic process, including tools used and any assumptions that were made about the tools or process; a series of sections detailing the findings for each device or drive\u2014accuracy is critical when findings are shared, and conclusions must be backed up with evidence and appropriate detail; and r."
  },
  {
    "id": 243,
    "topic_id": 4,
    "title": "Name four use cases for forensics.",
    "description": "Forensics may be used for investigations, incident response, intelligence, and counterintelligence."
  },
  {
    "id": 244,
    "topic_id": 5,
    "title": "What is used to ensure that organization that may be engaged in litigation retain relevant data?",
    "description": "A legal hold."
  },
  {
    "id": 245,
    "topic_id": 4,
    "title": "What documentation is created to demonstrate that forensic data and artifacts were handled properly and that they were not modified or changed during the forensic process?",
    "description": "Chain-of-custody documentation."
  },
  {
    "id": 246,
    "topic_id": 4,
    "title": "What is the process of obtaining and protecting forensic data called?",
    "description": "Preservation."
  },
  {
    "id": 247,
    "topic_id": 4,
    "title": "What is the process of conducting a digital investigation intended to find artifacts related to criminal activity or for litigation called?",
    "description": "E-discovery."
  },
  {
    "id": 248,
    "topic_id": 5,
    "title": "What are four types of documents in the information security policy framework?",
    "description": "Policies, standards, procedures, guidelines."
  },
  {
    "id": 249,
    "topic_id": 5,
    "title": "What term is used for a document that provides a high-level statement of management intent?",
    "description": "A policy."
  },
  {
    "id": 250,
    "topic_id": 1,
    "title": "What do many organizations use to coordinate changes to information systems?",
    "description": "Maintenance windows."
  },
  {
    "id": 251,
    "topic_id": 5,
    "title": "List the criteria that must be met for a compensating control to be satisfactory under PCI DSS.",
    "description": "Controls must meet the intent and rigor of the original requirement and must provide a similar level of defense, and must sufficiently offset the risk that the original PCI DSS requirement addressed. Existing PCI DSS requirements cannot be considered as compensating controls if they\u2019re already required for other assessed items, existing requirements may be considered as compensating controls if they are required for another area but are not required for the item under review."
  },
  {
    "id": 252,
    "topic_id": 1,
    "title": "What principle says that individuals should only be granted the minimum set of permissions necessary to carry out their job functions?",
    "description": "The principle of least privilege says that individuals should only be granted the minimum set of permissions necessary to carry out their job functions."
  },
  {
    "id": 253,
    "topic_id": 5,
    "title": "Give three examples of personnel management practices",
    "description": "Least privilege, separation of duties, job rotation and mandatory vacations, clean desk space, onboarding and offboarding, nondisclosure agreements (NDAs), social media, user training."
  },
  {
    "id": 254,
    "topic_id": 5,
    "title": "List four standard agreements used in third-party risk management",
    "description": "Master service agreements (MSA), ervice level agreements (SLAs), emorandum of understanding, memorandum of agreement (MOA), and usiness partners agreements."
  },
  {
    "id": 255,
    "topic_id": 5,
    "title": "What are three components in the NIST framework?",
    "description": "The Framework Core, the Framework Implementation, Framework Profile."
  },
  {
    "id": 256,
    "topic_id": 5,
    "title": "What is the difference between an audit and an assessment?",
    "description": "Audits are formal reviews of an organization\u2019s security program or specific compliance issues conducted on behalf of a third party. Assessments are less formal reviews of security controls that are typically requested by the security organization itself in an effort to engage in process improvement."
  },
  {
    "id": 257,
    "topic_id": 5,
    "title": "What is crucial for managing and mitigating third-party risks?",
    "description": "Effective vendor monitoring is crucial for managing and mitigating third-party risks."
  },
  {
    "id": 258,
    "topic_id": 5,
    "title": "What does establishing rules of engagement do?",
    "description": "Establishing rules of engagement helps define the boundaries within which the vendor should operate. They normally include setting clear communication protocols, defining responsibilities, and establishing processes for issue resolution."
  },
  {
    "id": 259,
    "topic_id": 1,
    "title": "What are threats, vulnerabilities, and risks?",
    "description": "Threats are any possible events that might have an adverse impact on the confidentiality, integrity, and/or availability of our information or information systems. Vulnerabilities are weaknesses in our systems or controls that could be exploited by a threat. Risks occur at the intersection of a vulnerability and a threat that might exploit that vulnerability. A threat without a corresponding vulnerability does not pose a risk, nor does a vulnerability without a corresponding threat."
  },
  {
    "id": 260,
    "topic_id": 5,
    "title": "What is the formula to calculate the severity of a risk?",
    "description": "Risk Severity = Likelihood * Impact."
  },
  {
    "id": 261,
    "topic_id": 5,
    "title": "What are two types of risk analyses and what are their differences?",
    "description": "Quantitative risk analyses use numeric data, resulting in assessments that allow the very straightforward prioritization of risks. Qualitative risk analysis substitutes subjective judgments and categories for strict numerical analysis, allowing the assessment of risks that are difficult to quantify."
  },
  {
    "id": 262,
    "topic_id": 5,
    "title": "Describe the process of quantitative risk analysis.",
    "description": "Determine the asset value (AV) of the asset affected by the risk. Determine the likelihood that the risk will occur. Determine the amount of damage that will occur to the asset if the risk materializes. Calculate the single loss expectancy. Calculate the annualized loss expectancy."
  },
  {
    "id": 263,
    "topic_id": 5,
    "title": "What are two important roles served by risk assessment in the risk management process?",
    "description": "The risk analysis provides guidance in prioritizing risks so that the risks with the highest probability and magnitude are addressed first. Quantitative risk analyses help determine whether the potential impact of a risk justifies the costs incurred by adopting a risk management approach."
  },
  {
    "id": 264,
    "topic_id": 5,
    "title": "What is risk mitigation?",
    "description": "The process of applying security controls to reduce the probability and/or magnitude of a risk."
  },
  {
    "id": 265,
    "topic_id": 5,
    "title": "What is risk avoidance?",
    "description": "A risk management strategy where you change your business practices to completely eliminate the potential that a risk will materialize."
  },
  {
    "id": 266,
    "topic_id": 5,
    "title": "What term describes the original level of risk that exists before implementing any controls?",
    "description": "The inherent risk facing an organization is the original level of risk that exists before implementing any controls. Inherent risk takes its name from the fact that it is the level of risk inherent in the organization\u2019s business."
  },
  {
    "id": 267,
    "topic_id": 3,
    "title": "What are four key metrics in the BIA process?",
    "description": "Mean Time Between Failures (MTBF) is the expected amount of time between system failures. Mean Time to Repair (MTTR) is the average amount of time to restore a system to its normal operating state after a failure. Recovery Time Objective (RTO) is the amount of time that the organization can tolerate a system being down before it is repaired. Recovery Point Objective (RPO) is the amount of data that the organization can tolerate losing during an outage."
  },
  {
    "id": 268,
    "topic_id": 3,
    "title": "What category of information includes any information that uniquely identifies an individual person, including customers, employees, and third parties?",
    "description": "Personally identifiable information (PII) includes any information that uniquely identifies an individual person, including customers, employees, and third parties."
  },
  {
    "id": 269,
    "topic_id": 3,
    "title": "What term refers to medical records maintained by health-care providers and other organizations that are subject to HIPAA?",
    "description": "Protected health information (PHI)."
  },
  {
    "id": 270,
    "topic_id": 3,
    "title": "What are the four major information classification categories used by the U.S. government?",
    "description": "Top secret, secret, confidential, and unclassified."
  },
  {
    "id": 271,
    "topic_id": 3,
    "title": "What are three tools that can be used in the data obfuscation process?",
    "description": "Hashing uses a hash function to transform a value in our dataset to a corresponding hash value. Tokenization replaces sensitive values with a unique identifier using a lookup table. Data masking partially redacts sensitive information by replacing some or all of sensitive fields with blank characters."
  },
  {
    "id": 272,
    "topic_id": 3,
    "title": "What is a data subject?",
    "description": "An individual whose personal data is being processed."
  },
  {
    "id": 273,
    "topic_id": 5,
    "title": "What is a data controller?",
    "description": "The entity who determines the reasons for processing personal information and directs the methods of processing that data."
  },
  {
    "id": 274,
    "topic_id": 3,
    "title": "What is a data steward?",
    "description": "An individual who carries out the intent of the data controller or stewardship responsibility but is responsible for the secure safekeeping of information."
  },
  {
    "id": 275,
    "topic_id": 3,
    "title": "What is a data custodian?",
    "description": "An individual or team who does not have controller or stewardship responsibility but is responsible for the secure safekeeping of information."
  },
  {
    "id": 276,
    "topic_id": 3,
    "title": "What is a data processor?",
    "description": "A service provider that processes personal information on behalf of a data controller."
  },
  {
    "id": 277,
    "topic_id": 5,
    "title": "What is a data protection officer (DPO)?",
    "description": "The European Union\u2019s General Data Protection Regulation (GDPR) requires that every data controller designate a data protection officer (DPO) who bears overall responsibility for carrying out the organization\u2019s data privacy efforts."
  },
  {
    "id": 278,
    "topic_id": 200,
    "title": "The three core objectives of cybersecurity are confidentiality, integrity, and availability.",
    "description": "Confidentiality ensures that unauthorized individuals are not able to gain access to sensitive information. Integrity ensures that there are no unauthorized modifications to information or systems, either intentionally or unintentionally. Availability ensures that information and systems are ready to meet the needs of legitimate users at the time those users request them."
  },
  {
    "id": 279,
    "topic_id": 200,
    "title": "Nonrepudiation prevents someone from denying that they took an action.",
    "description": "Nonrepudiation means that someone who performed some action, such as sending a message, cannot later deny having taken that action. Digital signatures are a common example of nonrepudiation. They allow anyone who is interested to confirm that a message truly originated with its purported sender."
  },
  {
    "id": 280,
    "topic_id": 200,
    "title": "Security controls may be categorized based on their mechanism of action and their intent.",
    "description": "Controls are grouped into the categories of managerial, operational, physical, and technical based on the way that they achieve their objectives. They are divided into the types of preventive, detective, corrective, deterrent, compensating, and directive based on their intended purpose."
  },
  {
    "id": 281,
    "topic_id": 200,
    "title": "Data breaches have significant and diverse impacts on organizations.",
    "description": "When an organization suffers a data breach, the resulting data loss often results in both direct and indirect damages. The organization suffers immediate financial repercussions due to the costs associated with the incident response, as well as long-term financial consequences due to reputational damage. This reputational damage may be difficult to quantify, but it also may have a lasting impact. In some cases, organizations may suffer operational damage if they experience availability damages, preventing them from accessing their own information."
  },
  {
    "id": 282,
    "topic_id": 200,
    "title": "Data must be protected in transit, at rest, and in use.",
    "description": "Attackers may attempt to eavesdrop on network transmissions containing sensitive information. This information is highly vulnerable when in transit unless protected by encryption technology. Attackers also might attempt to breach data stores, stealing data at rest. Encryption serves to protect stored data as well as data in transit. Data is also vulnerable while in use on a system and should be protected during data processing activities."
  },
  {
    "id": 283,
    "topic_id": 200,
    "title": "Data loss prevention systems block data exfiltration attempts.",
    "description": "DLP technology enforces information handling policies to prevent data loss and theft. DLP systems may function at the host level, using software agents to search systems for the presence of sensitive information. They may also work at the network level, watching for transmissions of unencrypted sensitive information. DLP systems detect sensitive information using pattern-matching technology and/or digital watermarking."
  },
  {
    "id": 284,
    "topic_id": 200,
    "title": "Data minimization reduces risk by reducing the amount of sensitive information that we maintain.",
    "description": "In cases where we cannot simply discard unnecessary information, we can protect information through deidentification and data obfuscation. The tools used to achieve these goals include hashing, tokenization, and masking of sensitive fields."
  },
  {
    "id": 285,
    "topic_id": 200,
    "title": "Threat actors differ in several key attributes.",
    "description": "We can classify threat actors using four major criteria. First, threat actors may be internal to the organization, or they may come from external sources. Second, threat actors differ in their level of sophistication and capability. Third, they differ in their available resources and funding. Finally, different threat actors have different motivations and levels of intent."
  },
  {
    "id": 286,
    "topic_id": 200,
    "title": "Threat actors come from many different sources.",
    "description": "Threat actors may be very simplistic in their techniques, such as unskilled attackers using exploit code written by others, or quite sophisticated, such as the advanced persistent threat posed by nation-state actors and organized crime. Hacktivists may seek to carry out political agendas, whereas competitors may seek financial gain. Employees and other users may pose an insider threat by working from within to attack your organization. The use of unapproved shadow IT systems may also expose your data to risk."
  },
  {
    "id": 287,
    "topic_id": 200,
    "title": "Attackers have varying motivations for their attacks.",
    "description": "Attackers may be motivated by many different drivers. Common motivations for attack include data exfiltration, espionage, service disruption, blackmail, financial gain, philosophical or political beliefs, revenge, disruption and chaos, or war. Some attackers may believe they are behaving ethically and acting in the best interests of society."
  },
  {
    "id": 288,
    "topic_id": 200,
    "title": "Attackers exploit different vectors to gain initial access to an organization.",
    "description": "Attackers may attempt to gain initial access to an organization remotely over the Internet, through a wireless connection, or by attempting direct physical access. They may also approach employees over email or social media. Attackers may seek to use removable media to trick employees into unintentionally compromising their networks, or they may seek to spread exploits through cloud services. Sophisticated attackers may attempt to interfere with an organization's supply chain."
  },
  {
    "id": 289,
    "topic_id": 200,
    "title": "Threat intelligence provides organizations with valuable insight into the threat landscape.",
    "description": "Security teams may leverage threat intelligence from public and private sources to learn about current threats and vulnerabilities. They may seek out detailed indicators of compromise and perform predictive analytics on their own data. Threat intelligence teams often supplement open source and closed source intelligence that they obtain externally with their own research."
  },
  {
    "id": 290,
    "topic_id": 200,
    "title": "Security teams must monitor for supply chain risks.",
    "description": "Modern enterprises depend on hardware, software, and cloud service vendors to deliver IT services to their internal and external customers. Vendor management techniques protect the supply chain against attackers seeking to compromise these external links into an organization's network. Security professionals should pay particular attention to risks posed by outsourced code development, cloud data storage, and integration between external and internal systems."
  },
  {
    "id": 291,
    "topic_id": 200,
    "title": "Understand and explain the different types of malware.",
    "description": "Malware includes ransomware, Trojans, worms, spyware, bloatware, viruses, keyloggers, logic bombs, and rootkits. Each type of malware has distinctive elements, and security analysts need to know what identifies each type of malware, how to identify it, what controls are commonly deployed against it, and what to do if you encounter it."
  },
  {
    "id": 292,
    "topic_id": 200,
    "title": "Explain common indicators of malicious activity associated with malware types.",
    "description": "Indicators of compromise associated with malware vary based on the type of malware and how it is designed and used. Common examples of IoCs associated with malware include command and control (C&C) traffic patterns, IP addresses, hostnames, and domains. Use of system utilities in unexpected ways, lateral movement between systems, creation of files and directories, encryption of files, and data exfiltration are also commonly seen, particularly with Trojans and rootkits. Signatures for malware are commonly used to identify specific files associated with given malware packages although malware writers use defensive techniques intended to make this harder."
  },
  {
    "id": 293,
    "topic_id": 200,
    "title": "Understand the methods to mitigate malware.",
    "description": "Malware may require specialized techniques and processes to remove it or to deal with the impact of the malware. Techniques range from manual removal to the use of tools to identify and remove malicious files, and often rely on reinstallation of a system or restoration from a known good backup to ensure all malware is removed."
  },
  {
    "id": 294,
    "topic_id": 200,
    "title": "Many techniques are used for social engineering.",
    "description": "Many adversarial and security techniques rely on social engineering. Phishing and its related techniques of smishing and vishing seek to gain information using social engineering techniques. Misinformation and disinformation campaigns are used to change opinions and to shift narratives. Malicious actors will impersonate whomever they need to acquire information, to gain access or credentials, or to persuade individuals to take action. Pretexting is often used with impersonation to provide a believable reason for the action or request. Business email compromise and brand impersonation are both used to make malicious emails and other communications appear legitimate and thus more likely to fool targets into taking desired action. Watering hole attacks focus on sites that target frequently visit, while typosquatters rely on users who make typos while entering URLs."
  },
  {
    "id": 295,
    "topic_id": 200,
    "title": "Passwords can be acquired and cracked in many ways.",
    "description": "Password attacks can be conducted both online against live systems and offline using captured password stores. Brute-force attacks like spraying and dictionary attacks as well as password cracking can recover passwords in many circumstances. Unencrypted or plain-text passwords and improper or unsecure storage methods like the use of MD5 hashes make attacks even easier for attackers who can access them."
  },
  {
    "id": 296,
    "topic_id": 200,
    "title": "Many vulnerabilities exist in modern computing environments.",
    "description": "Cybersecurity professionals should remain aware of the risks posed by vulnerabilities both on-premises and in the cloud. Improper or weak patch management can be the source of many of these vulnerabilities, providing attackers with a path to exploit operating systems, applications, and firmware. Weak configuration settings that create vulnerabilities include open permissions, unsecured root accounts, errors, weak encryption settings, insecure protocol use, default settings, and open ports and services. When a scan detects a vulnerability that does not exist, the report is known as a false positive. When a scan does not detect a vulnerability that actually exists, the report is known as a false negative."
  },
  {
    "id": 297,
    "topic_id": 200,
    "title": "Threat hunting discovers existing compromises.",
    "description": "Threat hunting activities presume that an organization is already compromised and search for indicators of those compromises. Threat hunting efforts include the use of advisories, bulletins, and threat intelligence feeds in an intelligence fusion program. They search for signs that attackers gained initial access to a network and then conducted maneuver activities on that network."
  },
  {
    "id": 298,
    "topic_id": 200,
    "title": "Vulnerability scans probe systems, applications, and devices for known security issues.",
    "description": "Vulnerability scans leverage application, network, and web application testing to check for known issues. These scans may be conducted in a credentialed or noncredentialed fashion and may be intrusive or nonintrusive, depending on the organization's needs. Analysts reviewing scans should also review logs and configurations for additional context. Vulnerabilities are described consistently using the Common Vulnerabilities and Exposures (CVE) standard and are rated using the Common Vulnerability Scoring System (CVSS). CVE and CVSS are components of the Security Content Automation Protocol (SCAP)."
  },
  {
    "id": 299,
    "topic_id": 200,
    "title": "Penetration testing places security professionals in the role of attackers.",
    "description": "Penetration tests may be conducted in a manner that provides the testers with full access to information before the test (known environment), no information at all (unknown environment), or somewhere in between those two extremes (partially known environment). Testers conduct tests within the rules of engagement and normally begin with reconnaissance efforts, including war driving, war flying, footprinting, and open source intelligence (OSINT). They use this information to gain initial access to a system. From there, they seek to conduct privilege escalation to increase their level of access and lateral movement/pivoting to expand their access to other systems. They seek to achieve persistence to allow continued access after the vulnerability they initially exploited is patched. At the conclusion of the test, they conduct cleanup activities to restore systems to normal working order and remove traces of their activity."
  },
  {
    "id": 300,
    "topic_id": 200,
    "title": "Bug bounty programs incentivize vulnerability reporting.",
    "description": "Bug bounty programs allow external security professionals to probe the security of an organization's public-facing systems. Testers who discover vulnerabilities are provided with financial rewards for their participation. This approach is a good way to motivate hackers to work for good, rather than using discovered vulnerabilities against a target."
  },
  {
    "id": 301,
    "topic_id": 200,
    "title": "Recognize the purpose and types of security audits.",
    "description": "Audits are formal examinations of an organization's security controls. They may be performed by internal audit teams or independent third-party auditors. At the conclusion of an audit, the audit team makes an attestation about the adequacy and effectiveness of the organization's security controls."
  },
  {
    "id": 302,
    "topic_id": 200,
    "title": "Understand the stages of the vulnerability life cycle.",
    "description": "The stages of the vulnerability life cycle are vulnerability identification, analysis, response and remediation, validation of remediation, and reporting. Vulnerability identification can come from scans, penetration tests, responsible disclosure or bug bounty programs, and audit results. Analysis involves confirming the vulnerability, prioritizing it using CVSS and CVE, and considering organization-specific factors. Responses include applying patches, isolating affected systems, implementing compensating controls, transferring risk through insurance, or formally accepting the risk. Validation ensures the vulnerability is no longer present, and reporting informs stakeholders about the findings, actions, trends, and recommendations for improvement."
  },
  {
    "id": 303,
    "topic_id": 200,
    "title": "Understand secure software development concepts.",
    "description": "Software should be created using a standardized software development life cycle that moves software through development, test, staging, and production environments. Developers should understand the issues associated with code reuse and software diversity. Web applications should be developed in alignment with industry-standard principles such as those developed by the Open Worldwide Application Security Project (OWASP)."
  },
  {
    "id": 304,
    "topic_id": 200,
    "title": "Know how to analyze the indicators associated with application attacks.",
    "description": "Software applications may suffer from a wide range of vulnerabilities that make them susceptible to attack. You should be familiar with these attacks, including memory injection, buffer overflow, and race condition attacks. You should also understand web-specific attacks, such as Structured Query Language injection (SQLi) and cross-site scripting (XSS). Understanding the methods behind these attacks helps security professionals build adequate defenses and identify attacks against their organizations."
  },
  {
    "id": 305,
    "topic_id": 200,
    "title": "Know how to implement application security controls.",
    "description": "Application security should be at the forefront of security operations principles. This includes protecting code through the use of input validation. Web applications that rely on cookies for session management should secure those cookies through the use of transport encryption. Code should be routinely subjected to code review as well as static and dynamic testing. Code signing provides end users with assurance that code came from a trusted source. Sandboxing allows the testing of code in an isolated environment."
  },
  {
    "id": 306,
    "topic_id": 200,
    "title": "Explain the common benefits and drawbacks of automation and scripting related to secure operations.",
    "description": "The main benefits of automation are achieving efficiency and saving time, enforcing baselines, standardizing infrastructure configurations, scaling in a secure manner, retaining employees, lowering reaction times, and serving as a workforce multiplier. The main drawbacks are complexity, cost, creating a single point of failure, building up technical debt, and maintaining ongoing supportability."
  },
  {
    "id": 307,
    "topic_id": 200,
    "title": "Explain common use cases of automation and scripting for cybersecurity.",
    "description": "Security professionals use automation and scripting techniques in many different use cases. These include user and resource provisioning, creating guard rails, managing security groups, creating and escalating tickets, enabling and disabling services and access, performing continuous integration and testing, and making use of application programming interfaces (APIs)."
  },
  {
    "id": 308,
    "topic_id": 200,
    "title": "Understand the goals of cryptography.",
    "description": "The four goals of cryptography are confidentiality, integrity, authentication, and non-repudiation. Confidentiality is the use of encryption to protect sensitive information from prying eyes. Integrity is the use of cryptography to ensure that data is not maliciously or unintentionally altered. Authentication refers to uses of encryption to validate the identity of individuals. Non-repudiation ensures that individuals can prove to a third party that a message came from its purported sender."
  },
  {
    "id": 309,
    "topic_id": 200,
    "title": "Explain the differences between symmetric and asymmetric encryption.",
    "description": "Symmetric encryption uses the same shared secret key to encrypt and decrypt information. Users must have some mechanism to exchange these shared secret keys. The Diffie\u2013Hellman algorithm provides one approach. Asymmetric encryption provides each user with a pair of keys: a public key, which is freely shared, and a private key, which is kept secret. Anything encrypted with one key from the pair may be decrypted with the other key from the same pair."
  },
  {
    "id": 310,
    "topic_id": 200,
    "title": "Explain how digital signatures provide non-repudiation.",
    "description": "Digital signatures provide non-repudiation by allowing a third party to verify the authenticity of a message. Senders create digital signatures by using a hash function to generate a message digest and then encrypting that digest with their own private key. Others may verify the digital signature by decrypting it with the sender's public key and comparing this decrypted message digest to one that they compute themselves using the hash function on the message."
  },
  {
    "id": 311,
    "topic_id": 200,
    "title": "Understand the purpose and use of digital certificates.",
    "description": "Digital certificates provide a trusted mechanism for sharing public keys with other individuals. Users and organizations obtain digital certificates from certificate authorities (CAs), who demonstrate their trust in the certificate by applying their digital signature. Recipients of the digital certificate can rely on the public key it contains if they trust the issuing CA and verify the CA's digital signature."
  },
  {
    "id": 312,
    "topic_id": 200,
    "title": "Demonstrate familiarity with emerging issues in cryptography.",
    "description": "Tor uses perfect forward secrecy to allow anonymous communication over the Internet. The blockchain is an immutable distributed public ledger made possible through the use of cryptography."
  },
  {
    "id": 313,
    "topic_id": 200,
    "title": "Identities are the foundation of authentication and authorization.",
    "description": "Users claim an identity through an authentication process. In addition to usernames, identities are often claimed through the use of certificates, tokens, SSH keys, or smartcards, each of which provides additional capabilities or features that can help with security or other useful functions. Identities use attributes to describe the user, with various attributes like job, title, or even personal traits stored as part of that user's identity."
  },
  {
    "id": 314,
    "topic_id": 200,
    "title": "Single sign-on and federation are core elements of many identity infrastructures.",
    "description": "Single sign-on (SSO) is widely used to allow users to log in once and use resources and services across an organization or federation. While there are many SSO technologies and implementations, LDAP, OAuth, and SAML are critical for many modern SSO designs."
  },
  {
    "id": 315,
    "topic_id": 200,
    "title": "Passwords, passwordless authentication, and multifactor authentication all have roles to play in authentication systems.",
    "description": "Passwords best practices include configuration common settings like password length, complexity, reuse, expiration, and age. Understanding what each setting helps with and why it might be configured to specific settings is an important task for security professionals. Password managers help to limit password reuse and to manage passwords for organizations when implemented with enterprise solutions. Multifactor authentication relies on additional factors beyond passwords, including biometrics and hardware- and software-based tokens like security keys and authenticator applications. Multifactor requires the use of distinct factors: potential factors include something you know, something you have, something you are, or somewhere you are."
  },
  {
    "id": 316,
    "topic_id": 200,
    "title": "Account types and account policies determine what users can do and privileged accounts must be managed and controlled.",
    "description": "Types of user accounts include users, guests, administrative (privileged) accounts, and service accounts. Provisioning and deprovisioning accounts as well as managing the account life cycle are key to ensuring that accounts have appropriate rights and that they do not remain after they are no longer needed. Privileged access management focuses on privileged accounts and rights, and leverages techniques like just-in-time permission granting and removal and short-lived, ephemeral accounts that exist just for the time needed to accomplish a task."
  },
  {
    "id": 317,
    "topic_id": 200,
    "title": "Access control schemes determine what rights accounts have.",
    "description": "Important access control schemes include attribute-based access control (ABAC), which employs user attributes to determine what access the user should get. Role-based access control (RBAC) makes decisions based on roles, whereas rule-based access control (also sometimes called RBAC) uses rules to control access. In addition to knowing these access control schemes, be familiar with mandatory access control (MAC), which relies on the system administrator to control access, and discretionary access control (DAC), which allows users to make decisions about access to files and directories they have rights to. PAM (privileged access management) is focused on controlling administrative accounts. Finally, test takers also need to know how to use and apply common filesystem permissions."
  },
  {
    "id": 318,
    "topic_id": 200,
    "title": "Redundancy builds resilience.",
    "description": "Redundant systems, networks, and even datacenters are a key element in ensuring availability. Redundant designs need to address the organizational risks and priorities that your organization faces to ensure the best trade-offs between cost and capabilities. Geographic dispersal; load balancers and clustering; power protection and redundancy; RAID; backups; and diversity of technologies, systems, cloud service providers, and platforms are all ways to build and ensure resiliency. Considerations include availability, resilience, cost, responsiveness, scalability, ease of deployment, risk transference, ease of recovery, patch availability, inability to patch, power, and compute. Capacity planning helps to ensure that there is enough capacity to handle issues and outages including ensuring you have enough people, technology, and infrastructure to recover. Multicloud environments as well as platform diversity can help ensure that a single technology or provider's outage or issue does not take your organization offline, but they create additional complexity and costs."
  },
  {
    "id": 319,
    "topic_id": 200,
    "title": "Backups help ensure organizations can recover from events and issues.",
    "description": "Backups are designed to meet an organization's restoration needs, including how long it takes to recover from an issue and how much data may be lost between backups. Backup locations and frequency are determined based on the organization's risk profile and recovery needs, with offsite backups being a preferred solution to avoid losing backups in the same disaster as the source systems. Snapshots, journaling, and replication each have roles to play in ensuring data is available and accessible. Encryption is used to keep backups secure both in-transit and at rest."
  },
  {
    "id": 320,
    "topic_id": 200,
    "title": "Response and recovery are critical when failures occur.",
    "description": "Failures will occur, so you need to know how to respond. Having a disaster recovery location, like a hot, warm, or cold site or a redundant cloud or hosted location, can help ensure that your organization can return to operations more quickly. Having a predetermined restoration order provides a guideline on what needs to be brought back online first due to either dependencies or importance to the organization. Testing, including tabletop exercises, failover testing, simulations, and parallel processing, are all common ways to ensure response and recovery will occur as planned."
  },
  {
    "id": 321,
    "topic_id": 200,
    "title": "Physical security controls are a first line of defense.",
    "description": "Keeping your site secure involves security controls like fences, lighting, alarms, bollards, access control vestibules, cameras, and other sensors. Ensuring that only permitted staff are allowed in using locks, badges, and guards helps prevent unauthorized visitors. Sensors must be selected to match the environment and needs of the organization. Infrared, ultrasonic, pressure, and microwave sensors have different capabilities and costs. Brute-force attacks, as well as attacks against RFID and environmental attacks, need to be considered in physical security design."
  },
  {
    "id": 322,
    "topic_id": 200,
    "title": "Explain the three major cloud service models.",
    "description": "In the anything-as-a-service (XaaS) approach to computing, there are three major cloud service models. Infrastructure-as-a-service (IaaS) offerings allow customers to purchase and interact with the basic building blocks of a technology infrastructure. Software-as-a-service (SaaS) offerings provide customers with access to a fully managed application running in the cloud. Platform-as-a-service (PaaS) offerings provide a platform where customers may run applications that they have developed themselves."
  },
  {
    "id": 323,
    "topic_id": 200,
    "title": "Describe the four major cloud deployment models.",
    "description": "Public cloud service providers deploy infrastructure and then make it accessible to any customers who wish to take advantage of it in a multitenant model. The term private cloud is used to describe any cloud infrastructure that is provisioned for use by a single customer. A community cloud service shares characteristics of both the public and private models. Community cloud services do run in a multitenant environment, but the tenants are limited to members of a specifically designed community. Hybrid cloud is a catch-all term used to describe cloud deployments that blend public, private, and/or community cloud services together."
  },
  {
    "id": 324,
    "topic_id": 200,
    "title": "Understand the shared responsibility model of cloud security.",
    "description": "Under the shared responsibility model of cloud security, cloud customers must divide responsibilities between one or more service providers and the customers' own cybersecurity teams. In an IaaS environment, the cloud provider takes on the most responsibility, providing security for everything below the operating system layer. In PaaS, the cloud provider takes over added responsibility for the security of the operating system itself. In SaaS, the cloud provider is responsible for the security of the entire environment, except for the configuration of access controls within the application and the choice of data to store in the service."
  },
  {
    "id": 325,
    "topic_id": 200,
    "title": "Implement appropriate security controls in a cloud environment.",
    "description": "Cloud customers should understand how to use the controls offered by providers and third parties to achieve their security objectives. This includes maintaining resource policies and designing resilient cloud implementations that achieve high availability across multiple zones. From a storage perspective, cloud customers should consider permissions, encryption, replication, and high availability. From a network perspective, cloud customers should consider the design of virtual networks with public and private subnets to achieve appropriate segmentation. From a compute perspective, customers should design security groups that appropriately restrict network traffic to instances and maintain the security of those instances."
  },
  {
    "id": 326,
    "topic_id": 200,
    "title": "Understand operating system and hardware vulnerabilities.",
    "description": "Operating systems may be vulnerable, host vulnerable services or applications, or may have weak or insecure configurations that need to be addressed. Patching, configuration management, and security baselines all play a role in operating system security. Hardware security frequently focuses on firmware updates and security as well as life cycle management to properly address end-of-life and legacy hardware issues."
  },
  {
    "id": 327,
    "topic_id": 200,
    "title": "Hardening and protecting systems relies on security tools and technology to keep systems secure.",
    "description": "Securing endpoint devices requires considering the entire device: how it boots, how data is secured, how it is configured, what services it provides, if its communications are secure, and how it is protected against network threats. Fortunately, security professionals have a wide range of tools, including secure and trusted boot, to protect against attacks on the boot process or drivers. Antivirus, antimalware, EDR, XDR, and data loss prevention tools provide insight into what systems are doing and where issues may exist while adding more controls that administrators and security professionals can use to keep systems and data secure. Network security tools like host intrusion prevention and detection systems, host firewalls, and similar tools can detect and often stop attacks from the network."
  },
  {
    "id": 328,
    "topic_id": 200,
    "title": "Hardening endpoints also relies on configuration, settings, policies, and standards to ensure system security.",
    "description": "Although tools and technology are important to protect endpoints, configuration and settings are also an important part of the process. Disabling unnecessary services, changing default passwords, applying settings in the Windows Registry or operating systems settings in Linux, and otherwise using built-in and add-on configuration options to match security configurations to the device's risk profile is critical. Finally, patch management for the operating system and the applications installed on devices protects against known vulnerabilities and issues."
  },
  {
    "id": 329,
    "topic_id": 200,
    "title": "Specialized systems like SCADA, ICS, and IoT systems exist throughout your organization and require unique security solutions.",
    "description": "SCADA and ICS or industrial control systems are used to manage and monitor factories, power plants, and many other major components of modern companies. IoT systems are Internet-connected devices that perform a wide variety of tasks, from monitoring to home automation and more. They may be controlled by third parties or have other security implications that must be addressed as part of a security plan to keep each endpoint secure."
  },
  {
    "id": 330,
    "topic_id": 200,
    "title": "Explain the importance of asset management for software, data, and hardware.",
    "description": "Assets must be managed from acquisition through their life cycle until disposal or decommissioning. Proper management includes ensuring that ownership and classification are maintained and tracked, and that inventories of assets are up to date and include appropriate information to support operations, security, and incident response needs."
  },
  {
    "id": 331,
    "topic_id": 200,
    "title": "Drive encryption and sanitization help prevent data exposure.",
    "description": "Encrypting drives and media helps keep them secure if they are stolen or lost. Full-disk encryption covers the entire drive, whereas volume or file encryption protects portions of the contents. Sanitizing drives and media involves wiping them using a secure deletion process, or their destruction to ensure that the data cannot be recovered. Using appropriate processes based on the security requirements for the data and the type of drive or media involved is critical to making sure that the data is properly removed."
  },
  {
    "id": 332,
    "topic_id": 200,
    "title": "The foundation of network security is a secure design.",
    "description": "Networks must be designed with security in mind. Considerations include the attack surface of the network and its attached devices, which drives placement and segmentation into different security zones based on risk or security requirements. Understanding what will happen when failures occur and dealing with those failures also influences design and choices around high availability. NAC and 802.1X protect networks from untrusted devices being connected, whereas port security and port-level protections like loop prevention and broadcast storm protection ensure that malicious or misconfigured systems do not cause network issues. Network taps and monitoring ports allow packet capture by creating a copy of traffic from other ports. VPNs are used to tunnel network traffic to another location, and they can be encrypted or simply tunneled. Key concepts like physical isolation, logical segmentation, use of secure protocols, use of reputation services, and tools like software-defined networking, zero trust, SD-WAN, and SASE all have their place in secure network design."
  },
  {
    "id": 333,
    "topic_id": 200,
    "title": "Network appliances are used to provide security services to networks and systems.",
    "description": "There are many types of network appliances. Jump servers provide a secure way to access systems in another security zone. Load balancers spread load among systems and can use different scheduling options as well as operational modes like active/active or active/passive designs. Proxy servers either centralize connections from a group of clients out to a server or from a group of servers out to clients, often as a load-balancing strategy. Web filters filter content and URLs to limit what information can enter and exit a network based on rules, and data loss prevention systems monitor to ensure that data that shouldn't leave systems or networks is identified and flagged, sent securely, or stopped. IDS and IPS devices identify and take action based on malicious behavior, signatures, or anomalies in traffic. Data collection devices like sensors and collectors help with data gathering. Firewalls, including next-generation firewalls, web application firewalls, and unified threat management appliances, are used to build security zones and are placed at trust boundaries. UTM devices combine many of these security features and capabilities into a single appliance or system. Access control lists are used by many devices, including switches and routers to determine what traffic can flow through them based on rules."
  },
  {
    "id": 334,
    "topic_id": 200,
    "title": "Network security services and management techniques help make sure that a network stays secure.",
    "description": "Out-of-band management puts management interfaces on a separate VLAN or physical network or requires direct connection to help prevent attackers from gaining access to management interfaces. DNS security is also limited, but DNSSEC helps validate DNS servers and responses. DNS servers must be properly configured to prevent zone transfers and other DNS attacks. Email security leverages DMARC, DKIM, and SPF to validate senders and domains. TLS is used broadly to protect network traffic, acting as a wrapper for many other protocols. Monitoring services and systems helps ensure that they remain online and accessible but require care due to the amount of information that can be generated and the fact that false positives are possible if the validation and monitoring does not fully validate service responses. File integrity monitors check to see if files have been changed and can alert on changes or restore existing files to a pre-change or pre-deletion state. Honeypots and honeynets are used to gather information about attackers, and honeyfiles and honeytokens are used to identify potential breaches and attackers who have gathered information from systems in your environment. Network devices are hardened, much like other devices, often based on standards and benchmarks."
  },
  {
    "id": 335,
    "topic_id": 200,
    "title": "Secure protocols provide ways to send and receive information securely.",
    "description": "Many original Internet protocols are not secure\u2014they do not provide encryption or authentication and can be captured and analyzed or modified. Using secure versions of protocols or using an alternate secure service and protocol is an important part of ensuring that a network is secure. Key protocols include voice and video protocols like SRTP; email protocols like IMAPS and POPS; and security protocols like DMARC, DKIM, and SPF. File transfers can be done via SFTP or FTPS instead of FTP, and directory services can be moved from LDAP to LDAPS. Some protocols do not have as many or as complete secure options. In fact, DNS, routing, and DHCP all have limited options for secure communications. Network administrators must take these into account while designing and operating their networks."
  },
  {
    "id": 336,
    "topic_id": 200,
    "title": "Network attacks drive network security decisions and design.",
    "description": "On-path attacks redirect traffic through a system that an attacker controls, allowing them to observe and potentially modify traffic. DNS attacks include domain hijacking, DNS poisoning, and URL redirection, but can be partially countered through the use of DNSSEC. Credential replay attacks take advantage of poorly designed or insecure protocols to send valid authentication hashes or other artifacts pretending to be a legitimate user. Malicious code ranging from worms to denial-of-service tools can impact networks and must be accounted for in design. Denial-of-service attacks and distributed denial-of-service attacks consume resources or target services to cause them to fail. Reflected denial-of-service attacks use spoofed source addresses to cause traffic to be sent to targets, whereas amplified denial-of-service attacks use small queries to get large results, amplifying their impact."
  },
  {
    "id": 337,
    "topic_id": 200,
    "title": "Modern enterprises rely on many types of wireless connectivity.",
    "description": "There are many wireless connectivity options for organizations and individuals. Devices may connect via cellular networks, which place the control of the network in the hands of cellular providers. Wi-Fi is widely used to connect devices to organizational networks at high speed, allowing ease of mobility while providing security using enterprise security protocols. Bluetooth provides connectivity between many devices and cellular is used to provide access from mobile devices and systems that can't connect to Wi-Fi or wired networks."
  },
  {
    "id": 338,
    "topic_id": 200,
    "title": "Secure wireless network designs take existing networks and physical spaces into account.",
    "description": "Site surveys include physical tours of a facility using tools that can identify existing wireless networks and access points as well as signal strengths and other details that help map the location. Network designs take into account channel spacing, access point placement, and even the composition of the building when placing access points."
  },
  {
    "id": 339,
    "topic_id": 200,
    "title": "Cryptographic and authentication protocols provide wireless security.",
    "description": "Both WPA2 and WPA3 are used in modern Wi-Fi networks. These protocols provide for both simple authentication protocols, like WPA2's preshared key mode, and for enterprise authentication models that rely on RADIUS servers to provide user login with organizational credentials. Both rely on cryptographic protocols to encrypt data in transit. Devices are frequently configured to use a variant of the Extensible Authentication Protocol (EAP) that supports the security needs of the organization and that is supported by the deployed wireless devices."
  },
  {
    "id": 340,
    "topic_id": 200,
    "title": "Understand mobile device vulnerabilities.",
    "description": "Sideloading involves copying programs from an external device or system, allowing them to be added to a device and potentially bypassing the device's application store. Jailbreaking provides root access to devices providing greater control but also creating security concerns because it bypasses the device's native security model."
  },
  {
    "id": 341,
    "topic_id": 200,
    "title": "Securing underlying wireless infrastructure requires strong network device administration and security practices.",
    "description": "Wireless controllers and access points must be protected, and installation considerations are important to consider for wireless devices. Like other network devices, controllers and APs need to be regularly patched and updated and must be configured securely. They also must have protected administrative interfaces and should be configured to log and report on the network, their own status, and security issues or potential problems. Heatmaps and site surveys help administrators understand the environment they are deploying into and operating in."
  },
  {
    "id": 342,
    "topic_id": 200,
    "title": "Managing mobile devices relies on both deployment methods and administrative tools.",
    "description": "Deployment methods include bring your own device; choose your own device; corporate-owned, personally enabled; and corporate owned, business only. The risks and rewards for each method need to be assessed as organizations choose which model to deploy their devices in. Once that decision is made, tools like mobile device management or unified endpoint management can be used to configure, secure, manage, and control the devices in a wide range of ways, from deploying applications to securely wiping devices if they are lost or stolen. You need to understand the capabilities and limitations of MDM and UEM products as well as the devices and operating systems that they can manage."
  },
  {
    "id": 343,
    "topic_id": 200,
    "title": "The incident response cycle and incident response process outline how to respond to an incident.",
    "description": "The Security+ exam's incident response cycle includes preparation, detection, analysis, containment, eradication, recovery, and lessons learned. A response process may not be in a single phase at a time, and phases may move forward or backward depending on discoveries and further events. Organizations train their staff and hold exercises like tabletop exercises, walk-throughs, and simulations to allow their teams to practice incident response."
  },
  {
    "id": 344,
    "topic_id": 200,
    "title": "Threat hunting uses data to identify potential indicators of compromise.",
    "description": "IoCs are a critical part of a modern threat hunter's toolkit. They include detecting things like account lockout, concurrent session usage, impossible travel, attempted access to blocked content, resource consumption, resource inaccessibility, out-of-cycle logging, and missing logs, among many other potential IoCs. IoCs are documented and published through threat feeds and other services and sources."
  },
  {
    "id": 345,
    "topic_id": 200,
    "title": "Data sources and data management for incident response provide insight into what occurred as well as investigative and detection tools.",
    "description": "Security information and event management (SIEM) tools are used in many organizations to gather and analyze data using dashboards, automated analysis, and manual investigation capabilities. Information such as vulnerability scan output, system configuration data, system and device logs, and other organizational data are ingested and analyzed to provide broad insight into events and incidents. Network traffic information is gathered using NetFlow, sFlow, and packet analyzers, among other tools. They provide useful information about bandwidth usage as well as details about which systems communicated, the ports and protocols in use, time and date, and other high-level information useful for incident analysis. In addition to log and event information, metadata from files and other locations is commonly used for incident investigation and incident response."
  },
  {
    "id": 346,
    "topic_id": 200,
    "title": "Mitigation techniques ensure that the impact of incidents are limited.",
    "description": "Incident responders use a variety of techniques to mitigate and contain and recover from incidents. One of the most common tasks is to change configuration for endpoint security solutions as well as devices. That may include using allow lists or block/deny lists, quarantining files or devices, making firewall changes, using MDM or DLP tools, adding content or URL filtering rules, or revoking or updating certificates. At the network and infrastructure level, isolation, containment, and segmentation are all used to separate systems involved in incidents from other systems or networks. Root cause analysis is used to determine why an incident was able to happen or why it happened and to guide preparation work to avoid future incidents."
  },
  {
    "id": 347,
    "topic_id": 200,
    "title": "Legal holds and e-discovery drive some forensic activities.",
    "description": "Organizations face legal cases and need to respond to legal holds, which require them to preserve and protect relevant information for the active or pending case. E-discovery processes also require forensic and other data to be provided as part of a legal case. Organizations must build the capability and technology to respond to these requirements in an appropriate manner to avoid losing cases in court and to support incident response processes."
  },
  {
    "id": 348,
    "topic_id": 200,
    "title": "Acquisition techniques and procedures ensure usable and admissible forensic data.",
    "description": "Different system components and resources are more likely to be changed or lost during the time it takes for a forensic acquisition. Thus, forensic practitioners refer to the order of volatility to determine what is the most volatile and what is the least volatile. Your forensic acquisition process should take the order of volatility into account as well as the circumstances of your acquisition process as part of incident response or legal holds to determine what to capture first."
  },
  {
    "id": 349,
    "topic_id": 200,
    "title": "There are many options for acquisition tools, and selecting the right tool combines technical needs and skillsets.",
    "description": "Image acquisition tools provide the ability to copy disks and volumes using a bit-by-bit method that will capture the complete image including unused or slack space. Acquisition processes vary based on where the data is located, including acquisition using snapshots of virtual machines, data volume copies for cloud environments, and disk images for workstations and mobile devices. Incident responders must bear in mind both maintaining a chain of custody and the specific technical requirements of the system or devices they are capturing data from."
  },
  {
    "id": 350,
    "topic_id": 200,
    "title": "Validation and preservation of forensic data is a key part of the forensic process.",
    "description": "Hashing drives and images ensures that the acquired data matches its source. Forensic practitioners continue to commonly use MD5 or SHA1 despite issues with both hashing methods because adversarial techniques are rarely at play in forensic examinations. Checksums can be used to ensure that data is not changed, but they do not create the unique fingerprints that hashes are also used to provide for forensic artifacts. Preservation requires following chain-of-custody processes as well as forethought about the use of write blockers, forensic copies, and documented processes and procedures."
  },
  {
    "id": 351,
    "topic_id": 200,
    "title": "Forensic reports must be well organized and to the point.",
    "description": "Forensic analysis doesn't end when the technical examination of devices and drives is over. Forensic reports summarize key findings, then explain the process, procedures and tools, and any limitations or assumptions that impact the investigation. Next, they detail the forensic findings with appropriate evidence and detail to explain how conclusions were reached. They conclude with recommendations or overall conclusions in more detail than the summary provided."
  },
  {
    "id": 352,
    "topic_id": 200,
    "title": "Security governance practices ensure that organizations achieve their strategic objectives.",
    "description": "Governance programs are the sets of procedures and controls put in place to allow an organization to effectively direct its work. Governance programs may involve the participation of a variety of boards, committees, and government regulators. Centralized governance models use a top-down approach that dictates how subordinate units meet security objectives, whereas decentralized governance models delegate the authority for meeting security objectives as the subordinate units see fit."
  },
  {
    "id": 353,
    "topic_id": 200,
    "title": "Policy frameworks consist of policies, standards, procedures, and guidelines.",
    "description": "Policies are high-level statements of management intent for the information security program. Standards describe the detailed implementation requirements for policy. Procedures offer step-by-step instructions for carrying out security activities. Compliance with policies, standards, and procedures is mandatory. Guidelines offer optional advice that complements other elements of the policy framework."
  },
  {
    "id": 354,
    "topic_id": 200,
    "title": "Organizations often adopt a set of security policies covering different areas of their security programs.",
    "description": "Common policies used in security programs include an information security policy, an acceptable use policy, a data ownership policy, a data retention policy, an account management policy, and a password policy. The specific policies adopted by any organization will depend on that organization's culture and business needs."
  },
  {
    "id": 355,
    "topic_id": 200,
    "title": "Policy documents should include exception processes.",
    "description": "Exception processes should outline the information required to receive an exception to security policy and the approval authority for each exception. The process should also describe the requirements for compensating controls that mitigate risks associated with approved security policy exceptions."
  },
  {
    "id": 356,
    "topic_id": 200,
    "title": "Change management is crucial to ensuring the availability of systems and applications.",
    "description": "The primary goal of change management is to ensure that changes do not cause outages. Change management processes ensure that appropriate personnel review and approve changes before implementation and ensure that personnel test and document the changes. Change review processes should carefully evaluate the potential impact of any change."
  },
  {
    "id": 357,
    "topic_id": 200,
    "title": "Organizations face a variety of security compliance requirements.",
    "description": "Merchants and credit card service providers must comply with the Payment Card Industry Data Security Standard (PCI DSS). Organizations handling the personal information of European Union residents must comply with the EU General Data Protection Regulation (GDPR). All organizations should be familiar with the national, territory, and state laws that affect their operations."
  },
  {
    "id": 358,
    "topic_id": 200,
    "title": "Standards frameworks provide an outline for structuring and evaluating cybersecurity programs.",
    "description": "Organizations may choose to base their security programs on a framework, such as the NIST Cybersecurity Framework (CSF) or International Organization for Standardization (ISO) standards. U.S. federal government agencies and contractors should also be familiar with the NIST Risk Management Framework (RMF). These frameworks sometimes include maturity models that allow an organization to assess its progress. Some frameworks also offer certification programs that provide independent assessments of an organization's progress toward adopting a framework."
  },
  {
    "id": 359,
    "topic_id": 200,
    "title": "Security training and awareness ensures that individuals understand their responsibilities.",
    "description": "Security training programs impart new knowledge on employees and other stakeholders. They should be tailored to meet the specific requirements of an individual's role in the organization. Security awareness programs seek to remind users of the information they have already learned, keeping their security responsibilities top-of-mind."
  },
  {
    "id": 360,
    "topic_id": 200,
    "title": "Risk identification and assessment helps organizations prioritize cybersecurity efforts.",
    "description": "Cybersecurity analysts seek to identify all of the risks facing their organization and then conduct a business impact analysis to assess the potential degree of risk based on the probability that it will occur and the magnitude of the potential effect on the organization. This work allows security professionals to prioritize risks and communicate risk factors to others in the organization."
  },
  {
    "id": 361,
    "topic_id": 200,
    "title": "Vendors are a source of external risk.",
    "description": "Organizations should conduct their own systems assessments as part of their risk assessment practices, but they should also conduct supply chain assessments as well. Performing vendor due diligence reduces the likelihood that a previously unidentified risk at a vendor will negatively impact the organization. Hardware source authenticity techniques verify that hardware was not tampered with after leaving the vendor's premises."
  },
  {
    "id": 362,
    "topic_id": 200,
    "title": "Organizations may choose from a variety of risk management strategies.",
    "description": "Risk avoidance strategies change business practices to make a risk irrelevant to the organization. Risk mitigation techniques seek to reduce the probability or magnitude of a risk. Risk transference approaches move some of the risk to a third party. Risk acceptance acknowledges the risk and continues normal business operations despite the presence of the risk."
  },
  {
    "id": 363,
    "topic_id": 200,
    "title": "Disaster recovery planning builds resiliency.",
    "description": "Disaster recovery plans activate when an organization experiences a natural or human-made disaster that disrupts its normal operations. The disaster recovery plan helps the organization quickly recover its information and systems and resume normal operations."
  },
  {
    "id": 364,
    "topic_id": 200,
    "title": "Privacy controls protect personal information.",
    "description": "Organizations handling sensitive personal information should develop privacy programs that protect that information from misuse and unauthorized disclosure. The plan should cover personally identifiable information (PII), protected health information (PHI), financial information, and other records maintained by the organization that might impact personal privacy."
  }
];
